import React, { Component, createRef } from "react";
import { Tooltip } from "react-tooltip";
import { Fieldset } from "primereact/fieldset";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import axios from "axios";
import ScrolltoTop from "../ScrollTop/ScrollTop";
import { connect } from "react-redux";
import Sidebar from "../Sidebar/Sidebar";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { setUserSessionAuthKey } from "../../Component/commonUtils";
import TranslationFile from "../15-Translation/locale/Translation_apps.json";
import { ProgressSpinner } from "primereact/progressspinner";
import NavBarHeader from "../NavBarHeader/NavBarHeader";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import "./CompanyInformation.css";
import Footer_contact_tab from "../Footerpage/Footer_contact_tab";
import { Messages } from "primereact/messages";
import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { setupLocales } from "../../Component/setupLocales";
import SieLoadingGif from "../../Assests/SIELoading.gif";
import NoAccess from "../../Component/NoAccess/NoAccess";

//Videos
import videoAddDeleteColumn from "../../Assests/Videos/Add_Delete_Column.mp4";
import videoDashboardNavigation from "../../Assests/Videos/videoplay.mp4";
import videoAddDeleteHeader from "../../Assests/Videos/Delete_Add_Header.mp4";
import { Slider } from "antd";

import CusomtLabel from "../../Component/SliderLabels/SliderLabels";
import { Password } from "primereact/password";
import ReactSlider from "react-slider";

const marks = {
  0: "0",
  1: "1",
  2: "2",
  3: "3"
};

const mapStateToProps = (state) => {
  return {
    companyInformation: state.companyInformation.companyInformation,
    sessionDetails: state.sessionDetails,
    login: state.login.login.values,
    sideBarReducer: state.sideBarReducer.sideBarReducer,
    currentPageName: state.currentPageName.currentPageName,
    readOnly: state.readOnly.readOnly,
    pricesToLogin: state.pricesToLogin.pricesToLogin,
    showWIPStatus: state.showWIPStatus.showWIPStatus
    // accessStatus: state.accessStatus.accessStatus,
  };
};
let sliderEventValue = 0;
let financialYearObj = {
    from: "",
    to: ""
  },
  financialYearArray = [],
  localeLang = "",
  SIEFileContentArray = [],
  sideBarGreenTickPages = [];
let companyInformationFyPropsValue = "";
let dataKeyIn = "";
let selectedFile = "",
  submissionLimitToDate,
  linkSharedUser,
  responsePaymentEntryNo = 0,
  allowEdit = true,
  isLoopDone = false,
  sliderCount = 0,
  annualReportHeaderRequestObj = {
    reportGUID: "",
    companyName: "",
    registrationNo: "",
    postalCode: "",
    city: "",
    currentYear: "",
    previousYear1: "",
    previousYear2: "",
    previousYear3: "",
    createdByUserID: 0
  },
  localData = "",
  localObject,
  dateValue,
  userDetailsFromLocalStorage,
  currentReportGUIDFromUrl,
  financialYearCalendarDatesArray = [],
  videoList = [];

let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
let userSelectedLanguage = localStorage.getItem("selectedLanguage");
let tourGuidePages = localStorage.getItem("tourGuidePages");
let currentPageTourGuideName = "companyInformation";

let steps = [
  {
    content: TranslationFile.TourGuide_CI_Import_Btn[userSelectedLanguage],
    styles: {
      options: {
        width: 300
      }
    },
    target: ".import-btn-upload",
    title: TranslationFile.IncomestateImportbtn[userSelectedLanguage],
    disableBeacon: true
  },
  {
    content: TranslationFile.TourGuide_CI_YearSelect_Btn[userSelectedLanguage],
    placement: "top",
    styles: {
      options: {
        width: 300
      }
    },
    target: ".slider__container",
    title: TranslationFile.dashboardFinYear[userSelectedLanguage],
    disableBeacon: true
  }
];

class CompanyInformation extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.state = {
      organizationNumber: "",
      disableCompanyNo: false,
      companyName: "",
      postalCode: null,
      city: "",
      isWrongOrganizationNo: false,
      checkCompanyName: false,
      isWrongPostalcodeFormat: false,
      checkCity: false,
      isExistingOrganization: false,
      fetchOrgNoApiCallStatus: false,
      importSIEFile: false,
      bolagsverketToast: false,
      isOrganizationNoMissing: false,
      isOrganizationNameMissing: false,
      isPostalCodeMissing: false,
      isCityMissing: false,
      callBackFromMergeYearValue: "",
      displayLabels: false,
      sliderValue: 0,
      financialYearSliderValue: 0,
      financialYearArrayState: [],
      SIEMissingFieldsErrorArrayState: [],
      visible: false,
      showProceedButton: false,
      isNavigated: false,
      showUserNamePasswordDialogBox: false,
      newUserPassword: "",
      newUserConfirmPassword: "",
            showPasswordTooltip: false,
      passwordValidation: {
        minLength: false,
        uppercase: false,
        number: false,
        specialChar: false
      },
      newUserName: "",
      newLastName: "",
      newUserUserId: "",
      newUserEmailId: "",
      currentStartingDate: "",
      calendarDateHardCodedValue: "",
      userSelectedDateState: "",
      isProceedButtonClicked: false,
      uploadedSIEFile: "",
      currentReportID: "",
      // hidePage:'',
      reportAccessStatusFromProps: "",
      randomVideoFileName: "",
      randomVideoFileTitle: "",
      tipsDialog: false,
      SIEErrors: "",
      run: false,
      showRemoveFYConfimationDialog: false,
      inputMaskValue: "",
      // isDialogOpen: false,
      isMasked: true,
      isDialogOpen:
        window.innerWidth < 1024 && !localStorage.getItem("hideBestViewDialog"),
      sideBarStatus: true,
      pageLoading: true,
      passwordMismatch: "",
      accessLevel: 0
    };
    
    this.passwordInputRef = React.createRef();
    this.setLabels = this.setLabels.bind(this);
    this.reactSlider = null;
    this.setReactSliderRef = this.setReactSliderRef.bind(this);
    this.callbackSIE = this.callbackSIE.bind(this);
    this.inputMaskRef = createRef();
    this.navigateToIncomeStatementPage =
      this.navigateToIncomeStatementPage.bind(this);
    this.insertRepresentatives = this.insertRepresentatives.bind(this);
    this.closeBolagsverketLimitedCompanyDialog =
      this.closeBolagsverketLimitedCompanyDialog.bind(this);
  }

  // Closes the "Bolagsverket - limited companies only" info dialog
  closeBolagsverketLimitedCompanyDialog() {
    this.setState({ showBolagsverketLimitedCompanyDialog: false });
  }

  callbackRemoveSIE = (SIEError) => {
    this.state({
      SIEMissingFieldsErrorArrayState: []
    });
  };

  cc = (e) => {};

  callbackSIE = (SIEFile) => {
    const { financialYearArrayState, organizationNumber, companyName } =
      this.state;
    let { companyInformation, login, sessionDetails } = this.props;

    let SIEFinancialYearArray = [];

    let companyInformationValue = {
      organizationname: "",
      organizationnumber: "",
      postalcode: "",
      city: "",
      financialYear: ""
    };

    let isSIEOrgNoExist = false,
      SIEOrgNoError = "",
      SIEFinancialYearError = "",
      SIEInvalidFinancialYearLineNo = 0,
      isSIEOrgNameExist = false,
      isSIEFinancialYearExist = true;

    SIEFile.length &&
      SIEFile.map((i, idx) => {
        let SIEFinancialYearObj = {
          from: "",
          to: ""
        };

        if (i.includes("#ORGNR")) {
          let SIEOrgNo = i.split("#ORGNR");
          let organizationNo = SIEOrgNo[1].replace(" ", "");
          if (SIEOrgNo.length > 1 && organizationNo != "") {
            let organizationNoCount = organizationNo.length;

            if (organizationNoCount < 10 || organizationNoCount > 11) {
              SIEOrgNoError = "Orgnization No. (#ORGNR) is invalid";
            } else {
              if (organizationNoCount == 11) {
                this.setState({
                  organizationNumber: organizationNo
                });

                companyInformationValue.organizationnumber = organizationNo;
                annualReportHeaderRequestObj.registrationNo = organizationNo;
              } else {
                var chr = "-";
                var pos = 6;

                organizationNo =
                  organizationNo.substring(0, pos) +
                  chr +
                  organizationNo.substring(pos, organizationNo.length);
                this.setState({
                  organizationNumber: organizationNo
                });

                annualReportHeaderRequestObj.registrationNo = organizationNo;
              }
              isSIEOrgNoExist = true;
            }
          }
        }

        if (i.includes("#FNAMN")) {
          let SIEOrgName = i.split("#FNAMN");
          if (SIEOrgName.length > 1 && SIEOrgName[1] != "") {
            let orgName = SIEOrgName[1].replace(/['"]+/g, "").substring(1);
            this.setState({
              companyName: orgName
            });
            isSIEOrgNameExist = true;

            companyInformationValue.organizationname = orgName;
            annualReportHeaderRequestObj.companyName = orgName;
          }
        }

        let formattedFromDateString = "",
          formattedToDateString = "";
        if (i.includes("#RAR")) {
          let SIEFinancialYear = i.split(" ");
          if (SIEFinancialYear.length > 1) {
            let SIEFromDate = SIEFinancialYear[2];
            if (SIEFromDate.length == 8) {
              formattedFromDateString =
                SIEFromDate.slice(0, 4) +
                "-" +
                SIEFromDate.slice(4, 6) +
                "-" +
                SIEFromDate.slice(6, 8);

              SIEFromDate = new Date(formattedFromDateString);
            } else {
              isSIEFinancialYearExist = false;
              SIEInvalidFinancialYearLineNo = idx + 1;

              if (SIEFinancialYearError != "") {
                SIEFinancialYearError += "," + SIEInvalidFinancialYearLineNo;
              } else {
                SIEFinancialYearError =
                  "Invalid Financial Year (#RAR) in line No: " +
                  SIEInvalidFinancialYearLineNo;
              }
            }

            let SIEToDate = SIEFinancialYear[3];

            if (SIEToDate.length == 8) {
              formattedToDateString =
                SIEToDate.slice(0, 4) +
                "-" +
                SIEToDate.slice(4, 6) +
                "-" +
                SIEToDate.slice(6, 8);

              SIEToDate = new Date(formattedToDateString);
            } else {
              isSIEFinancialYearExist = false;
              if (idx + 1 != SIEInvalidFinancialYearLineNo) {
                if (SIEFinancialYearError != "") {
                  SIEFinancialYearError += "," + (idx + 1);
                } else {
                  SIEFinancialYearError =
                    "Invalid Financial Year (#RAR) in line No: " + (idx + 1);
                }
              }
            }

            if (isSIEFinancialYearExist) {
              SIEFinancialYearObj.from = SIEFromDate;
              SIEFinancialYearObj.to = SIEToDate;

              SIEFinancialYearArray.push(SIEFinancialYearObj);
              companyInformationValue.financialYear = SIEFinancialYearArray;
            }

            let dateRange =
              formattedFromDateString + " - " + formattedToDateString;

            switch (SIEFinancialYear[1]) {
              case "0":
                annualReportHeaderRequestObj.currentYear = dateRange;
                break;
              case "-1":
                annualReportHeaderRequestObj.previousYear1 = dateRange;
                break;
              case "-2":
                annualReportHeaderRequestObj.previousYear2 = dateRange;
                break;
              case "-3":
                annualReportHeaderRequestObj.previousYear3 = dateRange;
                break;
            }
          }
        }
      });

    if (!isSIEOrgNoExist) {
      if (SIEOrgNoError == "") {
        SIEOrgNoError = "Orgnization No. (#ORGNR) is missing";
      }
      this.setState((prevState) => ({
        SIEMissingFieldsErrorArrayState: [
          ...prevState.SIEMissingFieldsErrorArrayState,
          SIEOrgNoError
        ]
      }));
    }

    if (!isSIEOrgNameExist) {
      this.setState((prevState) => ({
        SIEMissingFieldsErrorArrayState: [
          ...prevState.SIEMissingFieldsErrorArrayState,
          "Orgnization Name (#FNAMN)"
        ]
      }));
    }

    if (!isSIEFinancialYearExist) {
      this.setState((prevState) => ({
        SIEMissingFieldsErrorArrayState: [
          ...prevState.SIEMissingFieldsErrorArrayState,
          SIEFinancialYearError
        ]
      }));
    }

    if (SIEFinancialYearArray.length > 0) {
      this.setState({
        sliderValue: SIEFinancialYearArray.length - 1,
        financialYearArrayState: SIEFinancialYearArray
      });
    }

    if (!isSIEOrgNoExist || !isSIEOrgNameExist || !isSIEFinancialYearExist) {
      this.setState({
        organizationNumber: "",
        companyName: "",
        sliderValue: "",
        financialYearArrayState: ""
      });
    } else {
      this.setState({
        visible: false,
        showProceedButton: false,
        disableCompanyNo: true
      });

      this.insertAnnualReportHeader();
    }
    companyInformation.values = companyInformationValue;
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    let userTourGuide = JSON.parse(localStorage.getItem("TourGuide")) || false;

    if (userTourGuide) {
      if (
        tourGuidePages != null &&
        tourGuidePages.length > 0 &&
        tourGuidePages.includes(currentPageTourGuideName)
      ) {
        setTimeout(() => {
          this.setState({ run: false });
        }, 200);
      } else {
        setTimeout(() => {
          this.setState({ run: true });
        }, 200);
      }
    }

    const { isNavigated } = this.state;

    if (this.reactSlider) {
      this.setLabels();
    }

    this.setState({
      disableCompanyNo: false
    });

    if (!isNavigated) {
      setTimeout(() => {
        localStorage.setItem("navigateTo", "");
        localStorage.setItem("navigateToGUID", "");
      }, 1000);
    }

    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  }

  setPlayBack() {
    this.videoRef.current.playbackRate = 0.7;
  }

  componentWillMount() {
    window.scrollTo(0, 0);
    userSelectedLanguage = localStorage.getItem("selectedLanguage");

    steps = [
      {
        content: TranslationFile.TourGuide_CI_Import_Btn[userSelectedLanguage],
        styles: {
          options: {
            width: 300
          }
        },
        target: ".import-btn-upload",
        title: TranslationFile.IncomestateImportbtn[userSelectedLanguage],
        disableBeacon: true
      },
      {
        content:
          TranslationFile.TourGuide_CI_YearSelect_Btn[userSelectedLanguage],
        placement: "top",
        styles: {
          options: {
            width: 300
          }
        },
        target: ".slider__container",
        title: TranslationFile.dashboardFinYear[userSelectedLanguage],
        disableBeacon: true
      }
    ];

    if (userSelectedLanguage == "sw") {
      localeLang = "sv";
    } else if (userSelectedLanguage == "en") {
      localeLang = "en";
    }
    setupLocales(localeLang);
    userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    let {
      companyInformation,
      sessionDetails,
      currentPageName,
      sideBarReducer,
      readOnly
    } = this.props;

    // axios.get("/api/start").then((response) => {
    //   axios.defaults.headers.common["X-CSRF-TOKEN"] = response.data.csrfToken;
    // });

    videoList = [
      {
        videoPath: videoAddDeleteColumn,
        // videoTitle: "Add or Delete Column"
        videoTitle: ""
      },
      {
        videoPath: videoDashboardNavigation,
        // videoTitle: "Navigate to the report from dashboard"
        videoTitle: ""
      },
      {
        videoPath: videoAddDeleteHeader,
        // videoTitle: "Add or Delete Header"
        videoTitle: ""
      }
    ];

    const randomIndex = Math.floor(Math.random() * videoList.length);

    this.setState({
      randomVideoFileName: videoList[randomIndex].videoPath,
      randomVideoFileTitle: videoList[randomIndex].videoTitle
    });

    currentPageName.values = "Company Information";
    localStorage.setItem("currentPageName", "Income Statement");

    localData = localStorage.getItem("rebelSkoolUser");

    localObject = localData && JSON.parse(localData);
    if (localObject) {
      this.setState({
        newUserUserId: localObject.userID,
        newUserEmailId: localObject.emailID
      });
      if (localObject.userName == "") {
        this.setState({ showUserNamePasswordDialogBox: true });
      }
    }

    // sideBarGreenTickPages = [];
    sideBarGreenTickPages.push("My Dashboard");
    sideBarGreenTickPages = [...new Set(sideBarGreenTickPages)];
    let updatePossibleNavigationPagesListString = JSON.stringify(
      sideBarGreenTickPages
    );
    localStorage.setItem(
      "possibleAccessablePages",
      updatePossibleNavigationPagesListString
    );

    let navigatedFromDashboardFYs = [];

    annualReportHeaderRequestObj.reportGUID =
      sessionDetails.sessionDetails.values.uuid;

    let navigateToReportGUID = localStorage.getItem("navigateToGUID");
    let splittedUrl = window.location.href.split("/");
    currentReportGUIDFromUrl = splittedUrl[splittedUrl.length - 2];
    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data.paymentEntryNo != null) {
            responsePaymentEntryNo = response.data.paymentEntryNo;
            allowEdit = response.data.allowEdit;
            allowEdit = !allowEdit;
          }
          let responseData = response.data;
          if (response.data.allowEdit == null) allowEdit = true;
          // if(accessStatus && accessStatus.values != undefined) {

          //   this.setState({reportAccessStatusFromProps:accessStatus.values.reportAccessStatus})
          // }
          if (responseData.reportID != null) {
            // this.setState({hidePage: false})
            let reportAccessReq = {
              reportId: responseData.reportID
            };
            axios
              .post(
                "/annualReport/getAccessStatus",
                reportAccessReq,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {
                switch (response.data) {
                  case 2:
                    linkSharedUser = 2; //Write
                    break;
                  case 3:
                    linkSharedUser = 3; //Read Only
                    break;
                  case 4:
                    linkSharedUser = 4; //No Access
                    break;
                }

                this.setState({
                  accessLevel: linkSharedUser
                });

                if (responseData.packageEntryNo > 0) {
                  readOnly.values = true;
                }
                if (responseData.currentYear != "")
                  this.formatDateAndCreateFinancialYearArray(
                    responseData.currentYear,
                    navigatedFromDashboardFYs,
                    0
                  );

                if (responseData.previousYear1 != "")
                  this.formatDateAndCreateFinancialYearArray(
                    responseData.previousYear1,
                    navigatedFromDashboardFYs,
                    1
                  );

                if (responseData.previousYear2 != "")
                  this.formatDateAndCreateFinancialYearArray(
                    responseData.previousYear2,
                    navigatedFromDashboardFYs,
                    2
                  );

                if (responseData.previousYear3 != "")
                  this.formatDateAndCreateFinancialYearArray(
                    responseData.previousYear3,
                    navigatedFromDashboardFYs,
                    3
                  );

                if (responseData.postalCode == "") {
                  this.setState({ postalCode: "" });
                } else {
                  this.setState({ postalCode: responseData.postalCode });
                }
                this.setState({
                  organizationNumber: responseData.registrationNo,
                  companyName: responseData.companyName,
                  postalCode: responseData.postalCode,
                  city: responseData.city,
                  uploadedSIEFile: responseData.sIEFile
                });

                let navigatedResponseObj = {
                  organizationnumber: responseData.registrationNo,
                  organizationname: responseData.companyName,
                  postalcode: responseData.postalCode,
                  city: responseData.city,
                  financialYear: navigatedFromDashboardFYs
                };
                annualReportHeaderRequestObj.registrationNo =
                  responseData.registrationNo;
                annualReportHeaderRequestObj.companyName =
                  responseData.companyName;
                annualReportHeaderRequestObj.postalCode =
                  responseData.postalCode;
                annualReportHeaderRequestObj.city = responseData.city;
                annualReportHeaderRequestObj.companyName =
                  responseData.companyName;

                companyInformation.values = navigatedResponseObj;
                if (
                  companyInformation.values.financialYear != undefined &&
                  companyInformation.values.financialYear.length > 0
                ) {
                  submissionLimitToDate = moment(
                    companyInformation.values.financialYear[0].to
                  )
                    .add(7, "month")
                    .subtract(1, "day")._d;
                  submissionLimitToDate = moment(submissionLimitToDate).format(
                    "YYYY-MM-DD"
                  );
                }

                axios
                  .get(
                    "/annualReport/getCompletedPages?reportId=" +
                      responseData.reportID,
                    userSessionAuthKeyReturnValue
                  )
                  .then((completedStatementTypesResponse) => {
                    //////////////////
                    // let getCompletedPagesFromLS = localStorage.getItem('completedPages')
                    // getCompletedPagesFromLS = getCompletedPagesFromLS && JSON.parse(getCompletedPagesFromLS);
                    // getCompletedPagesFromLS = getCompletedPagesFromLS && getCompletedPagesFromLS.filter((val) => val.reportId == responseData.reportID)

                    // let respData = completedStatementTypesResponse.data;

                    //////////////////

                    // Merge with whatever is already unlocked locally instead of
                    // overwriting it - otherwise a page unlocked locally (e.g.
                    // "Income Statement" right after a successful Next click)
                    // gets erased the moment this backend response doesn't yet
                    // reflect it.
                    let existingAccessablePagesLS = localStorage.getItem(
                      "possibleAccessablePages"
                    );
                    let existingAccessablePagesArray =
                      (existingAccessablePagesLS &&
                        JSON.parse(existingAccessablePagesLS)) ||
                      [];

                    sideBarReducer.values =
                      completedStatementTypesResponse.data;
                    sideBarGreenTickPages = [
                      ...existingAccessablePagesArray,
                      ...completedStatementTypesResponse.data
                    ];
                    sideBarGreenTickPages.push(
                      "My Dashboard"
                      // "Company Information"
                    );
                    sideBarGreenTickPages = [...new Set(sideBarGreenTickPages)];
                    let updatePossibleNavigationPagesListString =
                      JSON.stringify(sideBarGreenTickPages);
                    localStorage.setItem(
                      "possibleAccessablePages",
                      updatePossibleNavigationPagesListString
                    );
                    this.setState({
                      reRender: true
                    });
                  });
              })
              .catch((error) => {
                this.setState({
                  accessLevel: error.response.data
                });

                // let noAccessURL =
                //   "/annualreport/" + currentReportGUIDFromUrl + "/no-access";
                // this.props.history.push(noAccessURL);
              });
          } else {
          }
          this.setState({ currentReportID: response.data.reportID });

          // }

          this.setState({
            pageLoading: false
          });
        })
        .catch((error) => {
          let noAccessURL =
            "/annualreport/" + currentReportGUIDFromUrl + "/no-access";
          this.props.history.push(noAccessURL);
        });
    } else {
      axios.get("/user/saveAnonymousUser").then((response) => {
        if (response.data) {
          let anonymousUser = {
            ["User-Session-Auth-Key"]: response.data
          };
          localStorage.setItem("rebelSkoolUser", JSON.stringify(anonymousUser));
          userSessionAuthKeyReturnValue = setUserSessionAuthKey();

          axios
            .get(
              "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {})
            .catch((error) => {
              let noAccessURL =
                "/annualreport/" + currentReportGUIDFromUrl + "/no-access";
              this.props.history.push(noAccessURL);
            });
        }
      });
      this.setState({
        pageLoading: false
      });
    }

    if (companyInformation.values != undefined) {
      this.setState({
        organizationNumber: companyInformation.values.organizationnumber,
        companyName: companyInformation.values.organizationname,
        postalCode: companyInformation.values.postalcode,
        city: companyInformation.values.city,
        financialYearArrayState: companyInformation.values.financialYear,
        sliderValue:
          companyInformation.values.financialYear.length > 0
            ? companyInformation.values.financialYear.length - 1
            : 0
      });
    }

    tourGuidePages = localStorage.getItem("tourGuidePages");
    if (tourGuidePages != null) {
      tourGuidePages = JSON.parse(tourGuidePages);
      if (!tourGuidePages.includes(currentPageTourGuideName)) {
        tourGuidePages.push(currentPageTourGuideName);
      }
      localStorage.setItem("tourGuidePages", JSON.stringify(tourGuidePages));
    } else {
      let currentPageTourGuideArray = [];
      currentPageTourGuideArray.push(currentPageTourGuideName);
      localStorage.setItem(
        "tourGuidePages",
        JSON.stringify(currentPageTourGuideArray)
      );
    }

    this.updatePossibleAccessPages();
  }

  updatePossibleAccessPages() {
    let getPossibleAccessablePages = localStorage.getItem(
      "possibleAccessablePages"
    );

    let getPossibleAccessablePagesArray = JSON.parse(
      getPossibleAccessablePages
    );

    if (getPossibleAccessablePagesArray == null) {
      let possibleNavigationPagesList = [
        "My Dashboard"
        // "Company Information"
      ];
    
      possibleNavigationPagesList = [...new Set(possibleNavigationPagesList)];
      let possibleNavigationPagesListString = JSON.stringify(
        possibleNavigationPagesList
      );
      localStorage.setItem(
        "possibleAccessablePages",
        possibleNavigationPagesListString
      );
      getPossibleAccessablePagesArray = possibleNavigationPagesList;
    }
    
    const {
      organizationNumber,
      companyName,
      postalCode,
      city,
      financialYearArrayState,
      financialYearSliderValue
    } = this.state;

    let isBasicInfoComplete =
      organizationNumber != "" &&
      organizationNumber != undefined &&
      companyName != "" &&
      companyName != undefined &&
      postalCode != "" &&
      postalCode != 0 &&
      postalCode != null &&
      postalCode != undefined &&
      city != "" &&
      city != undefined;

    let requiredYearsCount = (financialYearSliderValue || 0) + 1;
    let isFinancialYearComplete = true;

    if (
      !financialYearArrayState ||
      financialYearArrayState.length < requiredYearsCount
    ) {
      isFinancialYearComplete = false;
    } else {
      for (let idx = 0; idx < requiredYearsCount; idx++) {
        let entry = financialYearArrayState[idx];
        let isEntryValid =
          entry &&
          entry.from &&
          entry.to &&
          moment(entry.from).isValid() &&
          moment(entry.to).isValid();

        if (!isEntryValid) {
          isFinancialYearComplete = false;
          break;
        }
      }
    }

    if (isBasicInfoComplete && isFinancialYearComplete) {
      if (!getPossibleAccessablePagesArray.includes("Income Statement")) {
        getPossibleAccessablePagesArray.push("Income Statement");
        getPossibleAccessablePagesArray = [
          ...new Set(getPossibleAccessablePagesArray)
        ];
        localStorage.setItem(
          "possibleAccessablePages",
          JSON.stringify(getPossibleAccessablePagesArray)
        );
      }
    }
  }

  formatDateAndCreateFinancialYearArray(
    responseData,
    navigatedFromDashboardFYs,
    arrayIdx
  ) {
    let respDataCurrentYear = responseData && responseData.split(" - ");
    let fromDate = respDataCurrentYear[0];
    let toDate = respDataCurrentYear[1];

    fromDate = new Date(fromDate);
    toDate = new Date(toDate);

    let yearObj = {
      from: fromDate,
      to: toDate
    };

    navigatedFromDashboardFYs[arrayIdx] = yearObj;

    switch (arrayIdx) {
      case 0:
        annualReportHeaderRequestObj.currentYear = fromDate + " - " + toDate;
        break;

      case 1:
        annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
        break;

      case 2:
        annualReportHeaderRequestObj.previousYear2 = fromDate + " - " + toDate;
        break;

      case 3:
        annualReportHeaderRequestObj.previousYear3 = fromDate + " - " + toDate;
        break;
    }

    this.setState({
      sliderValue: arrayIdx,
      financialYearSliderValue: arrayIdx,
      financialYearArrayState: navigatedFromDashboardFYs
    });

    financialYearCalendarDatesArray = navigatedFromDashboardFYs;
  }

  setReactSliderRef(element) {
    this.reactSlider = element;
  }

  setLabels() {
    this.setState({ displayLabels: true });
  }

  resetCompanyInforState() {
    this.setState({
      organizationNumber: "",
      companyName: "",
      postalCode: "",
      city: ""
    });
  }

  organizationNoOnComplete(e) {
    let { companyInformation, sessionDetails, login } = this.props;

    this.setState({
      organizationNumber: e.value
      //bolagsverketToast  : true
    });

    annualReportHeaderRequestObj.registrationNo = e.value;
    annualReportHeaderRequestObj.reportGUID =
      sessionDetails.sessionDetails.values.uuid;
    // (annualReportHeaderRequestObj.createdByUserID =
    //   login == undefined ? 0 : login.userID),

    let companyInformationValue = {
      organizationname: "",
      organizationnumber: "",
      postalcode: "",
      city: ""
    };

    if (userSessionAuthKeyReturnValue) {
      axios
        .get("/organization/get/" + e.value, userSessionAuthKeyReturnValue)
        .then((response) => {
          if (response.data != "") {
            const orgName = response.data.organizationname || "";

            this.setState({
              organizationNumber: response.data.organizationnumber,
              companyName: orgName,
              postalCode: response.data.postalcode,
              city: response.data.city
            });

            companyInformationValue = {
              organizationname: orgName,
              organizationnumber: response.data.organizationnumber,
              postalcode: response.data.postalcode,
              city: response.data.city
            };

            annualReportHeaderRequestObj.companyName = orgName;
            annualReportHeaderRequestObj.postalCode = response.data.postalcode;
            annualReportHeaderRequestObj.city = response.data.city;
          } else {
            companyInformationValue.organizationnumber = e.value;
          }
          companyInformation.values = companyInformationValue;

          this.insertAnnualReportHeader(true);
        });
      this.updatePossibleAccessPages();
    }
  }

  insertRepresentatives(annualReportHeaderRequestObj) {
    axios
      .post(
        "/annualReportRepresentative/insertByOrgNo",
        annualReportHeaderRequestObj,
        userSessionAuthKeyReturnValue
      )
      .then((response) => {
        console.log(response);
        let isContainsAB = response.data;
        console.log("isContainsAB", isContainsAB);
        const isAB =
          /\bAB\b/i.test(isContainsAB) || /aktiebolag/i.test(isContainsAB);
        console.log("212313", isContainsAB, isAB);
        if (!isAB) {
          this.bolagsverketToast.show({
            severity: "info",
            summary: "Information",
            sticky: true,
            closable: false,

            content: () => (
              <div className="bolagsverket-toast-container">
                <i className="pi pi-info-circle bolagsverket-toast-icon"></i>
                <div className="bolagsverket-toast-content">
                  <div className="bolagsverket-toast-header">
                    <span className="bolagsverket-toast-header-text">
                      Information
                    </span>
                  </div>
                  <div className="bolagsverket-toast-message">
                    {TranslationFile.Information[userSelectedLanguage]}
                  </div>
                  <div className="bolagsverket-toast-footer">
                    <Button
                      label="OK"
                      className="p-button-sm bolagsverket-toast-ok-btn"
                      onClick={() => this.bolagsverketToast.clear()}
                    />
                  </div>
                </div>
              </div>
            )
          });
        }
      });
  }

  organizationNoOnChange(e) {
    if (e.value == "") {
      // Only clear the Organization Number itself.
      // Do NOT wipe out Company Name, Postal Code, or City -
      // those were filled in independently and should stay untouched.
      this.setState({
        organizationNumber: ""
      });
      annualReportHeaderRequestObj.registrationNo = "";
    }
    
  }

  companyNameOnChange(e) {
    this.setState({
      companyName: e.target.value
    });
  }

  companyNameOnInput(e) {
    this.setState({
      companyName: e.target.value
    });
  }

  companyNameOnBlur(e) {
    let companyNameValue = e.target.value;
    if (companyNameValue != "") {
      annualReportHeaderRequestObj.companyName = companyNameValue;
      this.insertAnnualReportHeader();
      this.updatePossibleAccessPages();
    }
  }

  PostalcodeOnChange(e) {
    const postalCodeValue = e.target.value;
    this.setState({
      postalCode: postalCodeValue,
      isWrongPostalcodeFormat: postalCodeValue.length === 5 ? false : this.state.isWrongPostalcodeFormat
    });
  }

  // postalCodeOnBlur(e) {
  //   const { companyInformation } = this.props;

  //   let postalCodeValue = e.target.value;
  //   // if (postalCodeValue != "") {
  //   annualReportHeaderRequestObj.postalCode = postalCodeValue;

  //   companyInformation.values.postalcode = postalCodeValue;

  //   this.insertAnnualReportHeader();
  //   this.updatePossibleAccessPages();
  //   // }
  // }

  postalCodeOnBlur(e) {
    const { companyInformation } = this.props;

    const postalCodeValue = e.target.value;

    if (postalCodeValue.length > 0 && postalCodeValue.length !== 5) {
      this.setState({ isWrongPostalcodeFormat: true });
      return; // do not save an incomplete postal code
    }
    this.setState({ isWrongPostalcodeFormat: false });
    // if (postalCodeValue != "") {
    annualReportHeaderRequestObj.postalCode = postalCodeValue;

    if (companyInformation.values != undefined) {
      companyInformation.values.postalcode = postalCodeValue;

      this.insertAnnualReportHeader();
      this.updatePossibleAccessPages();
    }
    // }
  }

  cityOnChange(e) {
    this.setState({
      city: e.target.value
    });
  }

  // cityOnBlur(e) {
  //   const { companyInformation } = this.props;
  //   let cityValue = e.target.value;
  //   // if (cityValue != "") {
  //   annualReportHeaderRequestObj.city = cityValue;
  //   companyInformation.values.city = cityValue;
  //   this.insertAnnualReportHeader();
  //   this.updatePossibleAccessPages();
  //   // }
  // }

  cityOnBlur(e) {
    const { companyInformation } = this.props;

    console.log(e, "## E");

    let cityValue = e.target.value;

    // if (cityValue != "") {
    annualReportHeaderRequestObj.city = cityValue;

    if (companyInformation.values != undefined) {
      companyInformation.values.city = cityValue;
      this.insertAnnualReportHeader();
      this.updatePossibleAccessPages();
    }
    // }
  }

  dateOnBlurNew(e, idx, isFromDate, isToDate) {
    const { calendarDateHardCodedValue } = this.state;
    dataKeyIn = "";

    if (calendarDateHardCodedValue != "") {
      if (calendarDateHardCodedValue.length == 6) {
        var year = calendarDateHardCodedValue.substr(0, 2);
        var month = calendarDateHardCodedValue.substr(2, 2);
        var date = calendarDateHardCodedValue.substr(4, 4);
        var newdate = "20" + year;
        newdate = newdate + "-" + month + "-" + date;
        dateValue = new Date(newdate);
      } else if (calendarDateHardCodedValue.length == 8) {
        if (calendarDateHardCodedValue.includes("-")) {
          let splittedFormat = calendarDateHardCodedValue.split("-");
          var year = "20" + splittedFormat[0];
          var month = splittedFormat[1];
          var date = splittedFormat[2];
          var newdate = year + "-" + month + "-" + date;

          dateValue = new Date(newdate);
        } else {
          var year = calendarDateHardCodedValue.substr(0, 4);
          var month = calendarDateHardCodedValue.substr(4, 2);
          var date = calendarDateHardCodedValue.substr(6, 5);
          var newdate = year;
          newdate = newdate + "-" + month + "-" + date;
          dateValue = new Date(newdate);
        }
      }

      const isValidDate = moment(dateValue, "YYYY-MM-DD", true).isValid();

      if (isValidDate) {
        if (isFromDate) {
          let financialYearDateOnBlurObj = {
            from: dateValue,
            // to: moment(dateValue).add(12, "month").subtract(1, "day")._d,
            to: moment(dateValue).add(11, "months").endOf("month").toDate()
          };

          financialYearCalendarDatesArray[idx] = financialYearDateOnBlurObj;
        }

        if (isToDate) {
          if (financialYearCalendarDatesArray[idx]) {
            financialYearCalendarDatesArray[idx].to = dateValue;
          } else {
            financialYearCalendarDatesArray[idx] = {
              from: null,
              to: dateValue
            };
          }
        }

        financialYearCalendarDatesArray.map((i, idx) => {
          if (!i) return; 
          switch (idx) {
            case 0:
              annualReportHeaderRequestObj.currentYear =
                moment(i.from).format("YYYY-MM-DD") +
                " - " +
                moment(i.to).format("YYYY-MM-DD");
              break;
            case 1:
              annualReportHeaderRequestObj.previousYear1 =
                moment(i.from).format("YYYY-MM-DD") +
                " - " +
                moment(i.to).format("YYYY-MM-DD");
              break;
            case 2:
              annualReportHeaderRequestObj.previousYear2 =
                moment(i.from).format("YYYY-MM-DD") +
                " - " +
                moment(i.to).format("YYYY-MM-DD");
              break;
            case 3:
              annualReportHeaderRequestObj.previousYear3 =
                moment(i.from).format("YYYY-MM-DD") +
                " - " +
                moment(i.to).format("YYYY-MM-DD");
              break;
          }
        });

        this.insertAnnualReportHeader();
        this.updatePossibleAccessPages();
        
      } else {
            let possibleAccessablePagesListLS = localStorage.getItem("possibleAccessablePages");    
            let possibleAccessablePagesListLSArray = possibleAccessablePagesListLS && JSON.parse(possibleAccessablePagesListLS);     
            if (possibleAccessablePagesListLSArray && possibleAccessablePagesListLSArray.includes("Income Statement")) 
              {
                possibleAccessablePagesListLSArray = possibleAccessablePagesListLSArray.filter((val) => val !== "Income Statement"); 
                localStorage.setItem("possibleAccessablePages",JSON.stringify(possibleAccessablePagesListLSArray));
              }
        this.toast.show({
          severity: "warn",
          summary: TranslationFile.validDateWarn[userSelectedLanguage],
          detail: TranslationFile.validDateWarn[userSelectedLanguage],
          life: 5000
        });
        switch (idx) {
          case 0:
            annualReportHeaderRequestObj.currentYear = "";
            break;
          case 1:
            annualReportHeaderRequestObj.previousYear1 = "";
            break;
          case 2:
            annualReportHeaderRequestObj.previousYear2 = "";
            break;
          case 3:
            annualReportHeaderRequestObj.previousYear3 = "";
            break;
        }
        // Only clear the field that was actually typed incorrectly -
        // do NOT wipe out the other, already-valid, years.
        financialYearCalendarDatesArray[idx] = undefined;
        this.insertAnnualReportHeader();
      }
    }

    this.setState({
      reRender: true
    });
  }

  dateOnInput(e, idx, isFromDate, isToDate) {}

  dateOnChangeNew(dateEvent, idx, isFromDate, isToDate) {
    const { companyInformation } = this.props;
    const { calendarDateHardCodedValue } = this.state;

    if (dateEvent.value != null) {
      if (isFromDate) {
        let financialYearDateOnChangeObj = {
          from: dateEvent.value,
          to: moment(dateEvent.value).add(11, "months").endOf("month").toDate()
        };

        // let financialYearDateOnChangeObj = {
        //   from: moment(dateEvent.value).format('YYYY-MM-DD'),
        //   to: moment(moment(dateEvent.value).add(12, "month").subtract(1, "day")._d).format('YYYY-MM-DD'),
        // };

        financialYearCalendarDatesArray[idx] = financialYearDateOnChangeObj;
      }

      if (isToDate) {
        if (financialYearCalendarDatesArray[idx]) {
          financialYearCalendarDatesArray[idx].to = dateEvent.value;
        } else {
          financialYearCalendarDatesArray[idx] = {
            from: null,
            to: dateEvent.value
          };
        }
      }

      if (companyInformation.values == undefined) {
        let companyInformationEmptyObj = {
          organizationname: "",
          organizationnumber: "",
          postalcode: "",
          city: "",
          financialYear: ""
        };

        companyInformationEmptyObj.financialYear =
          financialYearCalendarDatesArray;
        companyInformation.values = companyInformationEmptyObj;
      } else {
        companyInformation.values.financialYear =
          financialYearCalendarDatesArray;
      }

      let fromDate = financialYearCalendarDatesArray[idx]
        ? moment(financialYearCalendarDatesArray[idx].from).format(
            "YYYY-MM-DD"
          )
        : "";
      let toDate = financialYearCalendarDatesArray[idx]
        ? moment(financialYearCalendarDatesArray[idx].to).format(
            "YYYY-MM-DD"
          )
        : "";

      switch (idx) {
        case 0:
          annualReportHeaderRequestObj.currentYear = fromDate + " - " + toDate;
          break;

        case 1:
          annualReportHeaderRequestObj.previousYear1 =
            fromDate + " - " + toDate;
          break;

        case 2:
          annualReportHeaderRequestObj.previousYear2 =
            fromDate + " - " + toDate;
          break;

        case 3:
          annualReportHeaderRequestObj.previousYear3 =
            fromDate + " - " + toDate;
          break;
      }

      this.insertAnnualReportHeader();
    } else {
      dataKeyIn = dataKeyIn + "" + dateEvent.originalEvent.nativeEvent.data;
      dataKeyIn = dataKeyIn.replace("null", "");

      if (dataKeyIn.length == 6) {
      }

      this.setState({
        calendarDateHardCodedValue: dataKeyIn
      });
    }

    // let autoDate = {};
    //   for (let i = 0; i < sliderValue; i++) {
    //     let previousFinancialYearValue = i + 1;
    //     autoDate = {};
    //     autoDate.from = moment(financialYearCalendarDatesArray[i].from).subtract(
    //       12,
    //       "month"
    //     )._d;
    //     autoDate.to = moment(financialYearCalendarDatesArray[i].from).subtract(
    //       1,
    //       "day"
    //     )._d;
    //     financialYearCalendarDatesArray.push(autoDate);
    //   }

    this.setState({
      reRender: true
    });
  }

  simulatePrevFiancialYearDatesNew(count) {
    const { companyInformation } = this.props;

    let tempFyCalendarDatesArray = [];

    financialYearCalendarDatesArray &&
      financialYearCalendarDatesArray.length &&
      financialYearCalendarDatesArray.map((i, idx) => {
        if (idx < count) {
          tempFyCalendarDatesArray.push(i);
        }

        if (count == 0 && tempFyCalendarDatesArray.length == 0) {
          tempFyCalendarDatesArray.push(i);
        }
      });

    financialYearCalendarDatesArray = tempFyCalendarDatesArray;

    // annualReportHeaderRequestObj.previousYear1 = "";
    // annualReportHeaderRequestObj.previousYear2 = "";
    // annualReportHeaderRequestObj.previousYear3 = "";

    // let currentFy = financialYearCalendarDatesArray[0];
    // let calcDate = {};
    // let fromDate,
    //   toDate = "";

    if (count == 0) {
      annualReportHeaderRequestObj.previousYear1 = "";
      annualReportHeaderRequestObj.previousYear2 = "";
      annualReportHeaderRequestObj.previousYear3 = "";
    }

    if (
      count == 1 ||
      (count == 2 && annualReportHeaderRequestObj.previousYear1 == "") ||
      (count == 3 && annualReportHeaderRequestObj.previousYear1 == "")
    ) {
      let currentFy = financialYearCalendarDatesArray[0];
      let calcDate = {};
      let fromDate,
        toDate = "";

      calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
      calcDate.to = moment(currentFy.from).subtract(1, "day").toDate();

      fromDate = moment(calcDate.from).format("YYYY-MM-DD");
      toDate = moment(calcDate.to).format("YYYY-MM-DD");

      annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
      financialYearCalendarDatesArray.push(calcDate);

      annualReportHeaderRequestObj.previousYear2 = "";
      annualReportHeaderRequestObj.previousYear3 = "";
    }

    if (
      count == 2 ||
      (count == 3 && annualReportHeaderRequestObj.previousYear2 == "")
    ) {
      if (annualReportHeaderRequestObj.previousYear1 != "") {
        let prev1Fy = annualReportHeaderRequestObj.previousYear1;

        let calcDate = {};
        let fromDate,
          toDate = "";

        let prev1FySplit = prev1Fy.split(" - ");

        calcDate.from = moment(prev1FySplit[0]).subtract(12, "month")._d;
        calcDate.to = moment(prev1FySplit[0]).subtract(1, "day").toDate();

        fromDate = moment(calcDate.from).format("YYYY-MM-DD");
        toDate = moment(calcDate.to).format("YYYY-MM-DD");

        annualReportHeaderRequestObj.previousYear2 = fromDate + " - " + toDate;
        financialYearCalendarDatesArray.push(calcDate);

        annualReportHeaderRequestObj.previousYear3 = "";
      }
    }

    if (count == 3) {
      if (annualReportHeaderRequestObj.previousYear2 != "") {
        let prev2Fy = annualReportHeaderRequestObj.previousYear2;

        let calcDate = {};
        let fromDate,
          toDate = "";

        let prev2FySplit = prev2Fy.split(" - ");

        calcDate.from = moment(prev2FySplit[0]).subtract(12, "month")._d;
        calcDate.to = moment(prev2FySplit[0]).subtract(1, "day").toDate();

        fromDate = moment(calcDate.from).format("YYYY-MM-DD");
        toDate = moment(calcDate.to).format("YYYY-MM-DD");

        annualReportHeaderRequestObj.previousYear3 = fromDate + " - " + toDate;
        financialYearCalendarDatesArray.push(calcDate);
      }
    }

    // if (count == 0) {
    //   annualReportHeaderRequestObj.previousYear1 = "";
    //   annualReportHeaderRequestObj.previousYear2 = "";
    //   annualReportHeaderRequestObj.previousYear3 = "";
    // } else if (
    //   count == 1 ||
    //   (count == 2 && annualReportHeaderRequestObj.previousYear1 == "") ||
    //   (count == 3 && annualReportHeaderRequestObj.previousYear1 == "")
    // ) {
    //   let currentFy = financialYearCalendarDatesArray[0];
    //   let calcDate = {};
    //   let fromDate,
    //     toDate = "";

    //   calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
    //   calcDate.to = moment(currentFy.from).subtract(1, "day")._d;

    //   fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //   toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //   annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
    //   financialYearCalendarDatesArray.push(calcDate);

    //   annualReportHeaderRequestObj.previousYear2 = "";
    //   annualReportHeaderRequestObj.previousYear3 = "";
    // } else if (
    //   count == 2 ||
    //   (count == 3 && annualReportHeaderRequestObj.previousYear2 == "")
    // ) {
    //   if (annualReportHeaderRequestObj.previousYear1 != "") {
    //     let prev1Fy = annualReportHeaderRequestObj.previousYear1;

    //     let calcDate = {};
    //     let fromDate,
    //       toDate = "";

    //     let prev1FySplit = prev1Fy.split(" - ");

    //     calcDate.from = moment(prev1FySplit[0]).subtract(12, "month")._d;
    //     calcDate.to = moment(prev1FySplit[0]).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear2 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     annualReportHeaderRequestObj.previousYear3 = "";
    //   }
    // } else if (count == 3) {
    //   if (annualReportHeaderRequestObj.previousYear2 != "") {
    //     let prev2Fy = annualReportHeaderRequestObj.previousYear2;

    //     let calcDate = {};
    //     let fromDate,
    //       toDate = "";

    //     let prev2FySplit = prev2Fy.split(" - ");

    //     calcDate.from = moment(prev2FySplit[0]).subtract(12, "month")._d;
    //     calcDate.to = moment(prev2FySplit[0]).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear3 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);
    //   }
    // }

    // switch (count) {
    //   case 0:
    //   annualReportHeaderRequestObj.previousYear1 = "";
    //   annualReportHeaderRequestObj.previousYear2 = "";
    //   annualReportHeaderRequestObj.previousYear3 = "";
    //   break;

    //   case 1:
    //     calcDate = {};

    //   calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
    //   calcDate.to = moment(currentFy.from).subtract(1, "day")._d;

    //   fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //   toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //   annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
    //   financialYearCalendarDatesArray.push(calcDate);

    //   annualReportHeaderRequestObj.previousYear2 = "";
    //   annualReportHeaderRequestObj.previousYear3 = "";
    //   break;

    //   case 2:
    //     if (annualReportHeaderRequestObj.previousYear1 !='')
    //     {
    //       let prev1Fy = annualReportHeaderRequestObj.previousYear1;

    //       calcDate = {};

    //       calcDate.from = moment(prev1Fy.from).subtract(12, "month")._d;
    //       calcDate.to = moment(prev1Fy.from).subtract(1, "day")._d;

    //       fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //       toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //       annualReportHeaderRequestObj.previousYear2 = fromDate + " - " + toDate;
    //     }
    //     else
    //     {
    //       calcDate = {};

    //   calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
    //   calcDate.to = moment(currentFy.from).subtract(1, "day")._d;

    //   fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //   toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //   annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
    //   financialYearCalendarDatesArray.push(calcDate);
    //     }

    //     annualReportHeaderRequestObj.previousYear3 = "";
    // }

    // switch (count) {
    //   case 0:
    //     annualReportHeaderRequestObj.previousYear1 = "";
    //     annualReportHeaderRequestObj.previousYear2 = "";
    //     annualReportHeaderRequestObj.previousYear3 = "";
    //     break;

    //   case 1:
    //     calcDate = {};

    //     calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
    //     calcDate.to = moment(currentFy.from).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     annualReportHeaderRequestObj.previousYear2 = "";
    //     annualReportHeaderRequestObj.previousYear3 = "";

    //     break;

    //   case 2:
    //     calcDate = {};

    //     calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
    //     calcDate.to = moment(currentFy.from).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     let prev1Fy = financialYearCalendarDatesArray[1];

    //     calcDate = {};

    //     calcDate.from = moment(prev1Fy.from).subtract(12, "month")._d;
    //     calcDate.to = moment(prev1Fy.from).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear2 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     annualReportHeaderRequestObj.previousYear3 = "";
    //     break;

    //   case 3:
    //     calcDate = {};

    //     calcDate.from = moment(currentFy.from).subtract(12, "month")._d;
    //     calcDate.to = moment(currentFy.from).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear1 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     let prev1Fys = financialYearCalendarDatesArray[1];

    //     calcDate = {};

    //     calcDate.from = moment(prev1Fys.from).subtract(12, "month")._d;
    //     calcDate.to = moment(prev1Fys.from).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear2 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     let prev2Fy = financialYearCalendarDatesArray[2];

    //     calcDate = {};

    //     calcDate.from = moment(prev2Fy.from).subtract(12, "month")._d;
    //     calcDate.to = moment(prev2Fy.from).subtract(1, "day")._d;

    //     fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //     toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //     annualReportHeaderRequestObj.previousYear3 = fromDate + " - " + toDate;
    //     financialYearCalendarDatesArray.push(calcDate);

    //     break;
    // }

    // for (let i = 0; i < count; i++) {
    //   let calcDate = {};

    //   calcDate.from = moment(financialYearCalendarDatesArray[i].from).subtract(
    //     12,
    //     "month"
    //   )._d;
    //   calcDate.to = moment(financialYearCalendarDatesArray[i].from).subtract(
    //     1,
    //     "day"
    //   )._d;

    //   let fromDate = moment(calcDate.from).format("YYYY-MM-DD");
    //   let toDate = moment(calcDate.to).format("YYYY-MM-DD");

    //   switch (i) {
    //     case 0:
    //       annualReportHeaderRequestObj.previousYear1 =
    //         fromDate + " - " + toDate;
    //       financialYearCalendarDatesArray.push(calcDate);
    //       break;

    //     case 1:
    //       annualReportHeaderRequestObj.previousYear2 =
    //         fromDate + " - " + toDate;
    //       financialYearCalendarDatesArray.push(calcDate);
    //       break;

    //     case 2:
    //       annualReportHeaderRequestObj.previousYear3 =
    //         fromDate + " - " + toDate;
    //       financialYearCalendarDatesArray.push(calcDate);
    //       break;
    //   }
    // }

    companyInformation.values.financialYear = financialYearCalendarDatesArray;
    this.insertAnnualReportHeader();

    this.setState({
      reRender: true
    });
  }

  simulatePrevFiancialYearDatesNewOLD(count) {
    const { companyInformation } = this.props;
    let calcDate = {};

    let tempFyCalendarDatesArray = [];

    financialYearCalendarDatesArray &&
      financialYearCalendarDatesArray.length &&
      financialYearCalendarDatesArray.map((i, idx) => {
        if (idx <= count) {
          tempFyCalendarDatesArray.push(i);
        }
      });

    financialYearCalendarDatesArray = tempFyCalendarDatesArray;

    for (let i = 0; i <= count; i++) {
      let previousFinancialYearValue = i + 1;
      calcDate = {};

      calcDate.from = moment(financialYearCalendarDatesArray[i].from).subtract(
        12,
        "month"
      )._d;
      calcDate.to = moment(financialYearCalendarDatesArray[i].from).subtract(
        1,
        "day"
      )._d;

      let fromDate = moment(calcDate.from).format("YYYY-MM-DD");
      let toDate = moment(calcDate.to).format("YYYY-MM-DD");

      financialYearCalendarDatesArray[count] = calcDate;
      switch (count) {
        case 0:
          annualReportHeaderRequestObj.currentYear = fromDate + " - " + toDate;
          break;

        case 1:
          annualReportHeaderRequestObj.previousYear1 =
            fromDate + " - " + toDate;
          break;

        case 2:
          annualReportHeaderRequestObj.previousYear2 =
            fromDate + " - " + toDate;
          break;

        case 3:
          annualReportHeaderRequestObj.previousYear3 =
            fromDate + " - " + toDate;
          break;
      }
      companyInformation.values.financialYear = financialYearCalendarDatesArray;
      if (count == 0) {
        annualReportHeaderRequestObj.previousYear1 = "";
        annualReportHeaderRequestObj.previousYear2 = "";
        annualReportHeaderRequestObj.previousYear3 = "";
      }
      this.insertAnnualReportHeader();
    }

    this.setState({
      reRender: true
    });
  }

  simulatePrevFiancialYearDates(count) {
    const { financialYearArrayState } = this.state;
    let autoDate = {};

    let financialYearArrayLoc = financialYearArrayState;

    for (let i = 0; i < count; i++) {
      let previousFinancialYearValue = i + 1;
      autoDate = {};
      autoDate.from = moment(financialYearArrayState[i].from).subtract(
        12,
        "month"
      )._d;
      autoDate.to = moment(financialYearArrayState[i].from).subtract(
        1,
        "day"
      )._d;
      financialYearArrayState[previousFinancialYearValue] = autoDate;

      let fromDate = moment(autoDate.from).format("YYYY-MM-DD");
      let toDate = moment(autoDate.to).format("YYYY-MM-DD");

      let fromToDateRange = fromDate + " - " + toDate;

      if (previousFinancialYearValue == 1) {
        annualReportHeaderRequestObj.previousYear1 = fromToDateRange;
        annualReportHeaderRequestObj.previousYear2 = "";
        annualReportHeaderRequestObj.previousYear3 = "";
      }

      if (previousFinancialYearValue == 2) {
        annualReportHeaderRequestObj.previousYear2 = fromToDateRange;
      }

      if (previousFinancialYearValue == 3) {
        annualReportHeaderRequestObj.previousYear3 = fromToDateRange;
      }
    }

    if (count == 0) {
      annualReportHeaderRequestObj.previousYear1 = "";
      annualReportHeaderRequestObj.previousYear2 = "";
      annualReportHeaderRequestObj.previousYear3 = "";
    }

    this.insertAnnualReportHeader();
  }

  insertAnnualReportHeaderNew() {
    const { companyInformation, sessionDetails } = this.props;
    let userSessionAuthKeyReturnValue = setUserSessionAuthKey();

    if (userSessionAuthKeyReturnValue) {
      axios
        .post(
          "/annualReport/insertReportHeader",
          annualReportHeaderRequestObj,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data != "") {
            let updateJsonTableObj = {
              pageName: "Company Information",
              guid: sessionDetails.sessionDetails.values.uuid,
              json: JSON.stringify(companyInformation)
            };
            axios
              .post(
                "/annualReportLine/updateLinesJsonTable",
                updateJsonTableObj,
                userSessionAuthKeyReturnValue
              )
              .then((response) => {});
          }
        });
    }
  }

  insertAnnualReportHeader(insertOrgNo) {
    let { login, companyInformation, sessionDetails } = this.props;
    const { sliderValue, financialYearArrayState } = this.state;

    // let localData = localStorage.getItem("rebelSkoolUser");
    if (userSessionAuthKeyReturnValue) {
      this.updateFyDatesAndInsertHeaders(
        companyInformation,
        financialYearArrayState,
        sessionDetails,
        insertOrgNo
      );
    }

    // if (localData == "null") {
    //   axios.get("/user/saveAnonymousUserAccount").then((response) => {
    //     if (response.data) {
    //       let anonymousUser = {
    //         userSessionAuthKey: response.data,
    //       };
    //       localStorage.setItem("rebelSkoolUser", JSON.stringify(anonymousUser));
    //       this.updateFyDatesAndInsertHeaders(
    //         companyInformation,
    //         financialYearArrayState,
    //         sessionDetails
    //       );
    //     }
    //   });
    // } else {
    //   this.updateFyDatesAndInsertHeaders(
    //     companyInformation,
    //     financialYearArrayState,
    //     sessionDetails
    //   );
    // }
  }

  handleSliderChangeNew = (event, newValue) => {
    const { financialYearSliderValue } = this.state;
    sliderEventValue = event;

    if (financialYearCalendarDatesArray.length > 0) {
      //If financialYearSliderValue is lesser than the event, then the user increased the slider value and we should allow it as usual
      if (financialYearSliderValue < event) {
        this.setState({
          financialYearSliderValue: event
        });
        this.simulatePrevFiancialYearDatesNew(event);
      }

      //If the financialYearSliderValue is greater than the event, then the user decreased the slider value and we have to remove the Previous FYs
      else {
        //For that, we have to check if the report has any records for that FY by passing the reportGUID to the API
        //In that API, we have to check if the report has any value for that FY in Lines and Details table
        if (userSessionAuthKeyReturnValue) {
          axios
            .get(
              "/annualReportLine/checkAnnualReportLinesExistForFY?reportGUID=" +
                currentReportGUIDFromUrl,
              userSessionAuthKeyReturnValue
            )
            .then((response) => {
              //If he has, return true and ask that the data will be deleted if he procced.
              if (response.data) {
                this.setState({ showRemoveFYConfimationDialog: true });
                //The Confirmation Dialog box will Open
                //If he click Yes => Call an API to delete the data related to the reportId in Lines, Details and JSONLines table and allow him to decrease the slider
                //If he click No => close the dialog box and stay in the slider current value
              } else {
                //If he does not have, return false and allow him to decrease the slider
                this.setState({
                  financialYearSliderValue: event
                });
                this.simulatePrevFiancialYearDatesNew(event);
              }
            });
        }
      }
    } else {
      return this.toast.show({
        severity: "error",
        summary: TranslationFile.IncompleteText[userSelectedLanguage],
        detail: TranslationFile.FillStartingAndEndingDate[userSelectedLanguage],
        life: 5000
      });
    }
  };

  deleteSelectedFY() {
    const { financialYearSliderValue } = this.state;

    if (userSessionAuthKeyReturnValue) {
      //Call an API to delete the data related to the reportId in Lines, Details and JSONLines table and allow him to decrease the slider
      axios
        .get(
          "/annualReportLine/deletePreviousFYFromReport?reportGUID=" +
            currentReportGUIDFromUrl +
            "&sliderCount=" +
            sliderEventValue,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            this.toast.show({
              severity: "success",
              summary: "Previous Financial Year Values Removed",
              detail: "Previous Financial Year Values Removed",
              life: 5000
            });
            this.setState({
              showRemoveFYConfimationDialog: false,
              financialYearSliderValue: sliderEventValue
            });
            // this.simulatePrevFiancialYearDatesNew(sliderEventValue);
          }
        });
    }
  }

  deleteFormFooter = (
    //If he click Yes => Call an API to delete the data related to the reportId in Lines, Details and JSONLines table and allow him to decrease the slider
    //If he click No => close the dialog box and stay in the slider current value
    <div>
      <Button
        label={TranslationFile.yesBtn[userSelectedLanguage]}
        icon="pi pi-check"
        onClick={() => this.deleteSelectedFY()}
        className="p-button-text"
      />

      <Button
        label={TranslationFile.noBtn[userSelectedLanguage]}
        icon="pi pi-times"
        onClick={() => this.setState({ showRemoveFYConfimationDialog: false })}
        autoFocus
      />
    </div>
  );

  handleSliderChange = (event, newValue) => {
    const { financialYearArrayState } = this.state;
    if (financialYearArrayState.length > 0) {
      this.setState({
        sliderValue: event
      });
    } else {
      return this.toast.show({
        severity: "error",
        summary: TranslationFile.IncompleteText[userSelectedLanguage],
        detail:
          TranslationFile.ThankFillStartingAndEndingDateForSubscribing[
            userSelectedLanguage
          ],
        life: 5000
      });
    }

    this.simulatePrevFiancialYearDates(event);
  };

  updateFyDatesAndInsertHeaders(
    companyInformation,
    financialYearArrayState,
    sessionDetails,
    insertOrgNo
  ) {
    let fyArray = [];
    this.formatFinancialYearDate(
      annualReportHeaderRequestObj.currentYear,
      fyArray,
      "currentYear"
    );
    this.formatFinancialYearDate(
      annualReportHeaderRequestObj.previousYear1,
      fyArray,
      "previousYear1"
    );
    this.formatFinancialYearDate(
      annualReportHeaderRequestObj.previousYear2,
      fyArray,
      "previousYear2"
    );
    this.formatFinancialYearDate(
      annualReportHeaderRequestObj.previousYear3,
      fyArray,
      "previousYear3"
    );

    let userSessionAuthKeyReturnValue = setUserSessionAuthKey();
    if (userSessionAuthKeyReturnValue) {
      axios
        .post(
          "/annualReport/insertReportHeader",
          annualReportHeaderRequestObj,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          if (response.data) {
            let finalFyArrayObj = [];
            if (companyInformationFyPropsValue != "") {
              companyInformation.values.financialYear =
                companyInformationFyPropsValue;
            }

            if (insertOrgNo) {
              annualReportHeaderRequestObj.fetchRepButton = false;
              this.insertRepresentatives(annualReportHeaderRequestObj);
            }

            switch (sliderCount) {
              case 0:
                finalFyArrayObj = financialYearArrayState.slice(0, 1);
                break;

              case 1:
                finalFyArrayObj = financialYearArrayState.slice(0, 2);
                break;

              case 2:
                finalFyArrayObj = financialYearArrayState.slice(0, 3);
                break;

              case 3:
                finalFyArrayObj = financialYearArrayState.slice(0, 3);
                break;
            }

            if (companyInformation.values == undefined) {
              let companyInformationEmptyObj = {
                organizationname: "",
                organizationnumber: "",
                postalcode: "",
                city: "",
                financialYear: ""
              };

              companyInformationEmptyObj.financialYear = fyArray;

              companyInformation.values = companyInformationEmptyObj;
            } else {
              companyInformation.values.financialYear = fyArray;
            }

            // if (finalFyArrayObj.length > 0) {
            //   finalFyArrayObj.map((i, idx) => {
            //     return (
            //       (i.from = moment(i.from).format("YYYY-MM-DD")),
            //       (i.to = moment(i.to).format("YYYY-MM-DD"))
            //     );
            //   });

            //   companyInformation.values.financialYear = finalFyArrayObj;
            // }

            // companyInformation.values.financialYear = finalFyArrayObj;

            if (userSessionAuthKeyReturnValue) {
              let updateJsonTableObj = {
                pageName: "Company Information",
                guid: sessionDetails.sessionDetails.values.uuid,
                json: JSON.stringify(companyInformation)
              };
              axios
                .post(
                  "/annualReportLine/updateLinesJsonTable",
                  updateJsonTableObj,
                  userSessionAuthKeyReturnValue
                )
                .then((response) => {});
            }
          }
        });
    } else {
    }
  }

  formatFinancialYearDate(financialYearDate, fyArray, financialYearString) {
    let respDataCurrentYear = financialYearDate.split(" - ");

    if (respDataCurrentYear.length > 1) {
      let fromDate = respDataCurrentYear[0];
      let toDate = respDataCurrentYear[1];

      if (fromDate.length != 10) {
        fromDate = moment(fromDate).format("YYYY-MM-DD");
        toDate = moment(toDate).format("YYYY-MM-DD");
      }
      annualReportHeaderRequestObj[financialYearString] =
        fromDate + " - " + toDate;

      let dateObj = {
        from: fromDate,
        to: toDate
      };

      fyArray.push(dateObj);
    }
  }

  createElements(number) {
    const { financialYearArrayState } = this.state;
    const { companyInformation } = this.props;

    var elements = [];
    sliderCount = number;
    const currentDateMinus13Months = this.subtractMonths(new Date(), 13);

    for (let i = 0; i < number; i++) {
      elements.push(
        <center>
          <div className="year-div">
            <br></br>
            <div className="year-cal-label-head">
              {TranslationFile.IncomestateYearPrevious[userSelectedLanguage]} -{" "}
              {i + 1}
            </div>
            {/* <div className="pre-year-cal-label">
              <span className="pre-year-cal-label-1">
                {TranslationFile.IncomestateYearStartdate[userSelectedLanguage]}
              </span>
              <span className="pre-year-cal-label-2">
                {TranslationFile.IncomestateYearEnddate[userSelectedLanguage]}
              </span>
            </div> */}
            {/* <div className="year-cal-box">
              <Calendar
                id="icon"
                value={
                  financialYearCalendarDatesArray[i + 1] != undefined
                    ? financialYearCalendarDatesArray[i + 1].from
                    : ""
                }
                onChange={(e) => {
                  this.dateOnChangeNew(e, i + 1, true, false);
                }}
                onBlur={(e) => this.dateOnBlurNew(e, i + 1, true, false)}
                showIcon
                dateFormat="yy-mm-dd"
                placeholder={TranslationFile.YearFormat[userSelectedLanguage]}
                maxDate={new Date()}
                disabled={linkSharedUser == 3 || responsePaymentEntryNo > 0}
                locale={localeLang}
              />
              <Calendar
                id="icon"
                value={
                  financialYearCalendarDatesArray[i + 1] != undefined
                    ? financialYearCalendarDatesArray[i + 1].to
                    : ""
                }
                onChange={(e) => {
                  this.dateOnChangeNew(e, i + 1, false, true);
                }}
                onBlur={(e) => this.dateOnBlurNew(e, i + 1, false, true)}
                showIcon
                dateFormat="yy-mm-dd"
                placeholder={TranslationFile.YearFormat[userSelectedLanguage]}
                disabled={linkSharedUser == 3 || responsePaymentEntryNo > 0}
                locale={localeLang}
              />
            </div> */}

            <Row className="companyInfoFyRow">
              <Col>
                <div className="companyInfoStartEndDateLbl">
                  <div className="companyInfoStartDateLblDiv">
                    {
                      TranslationFile.IncomestateYearStartdate[
                        userSelectedLanguage
                      ]
                    }
                  </div>

                  <Calendar
                    id="icon"
                    value={
                      financialYearCalendarDatesArray[i + 1]?.from || ""
                    }
                    onChange={(e) => {
                      this.dateOnChangeNew(e, i + 1, true, false);
                    }}
                    onBlur={(e) => this.dateOnBlurNew(e, i + 1, true, false)}
                    // minDate={new Date(2020, 0, 1)}
                    showIcon
                    dateFormat="yy-mm-dd"
                    placeholder={
                      TranslationFile.YearFormat[userSelectedLanguage]
                    }
                    viewDate={currentDateMinus13Months}
                    disabled={
                      linkSharedUser == 3 ||
                      (responsePaymentEntryNo > 0 && allowEdit == true)
                    }
                    locale={localeLang}
                  />
                </div>
              </Col>
              <Col>
                {" "}
                <div className="companyInfoStartEndDateLbl">
                  {/* {
                                    TranslationFile.IncomestateYearEnddate[
                                      userSelectedLanguage
                                    ]
                                  } */}
                  <div className="companyInfoEndDateLblDiv">
                    {
                      TranslationFile.IncomestateYearEnddate[
                        userSelectedLanguage
                      ]
                    }
                  </div>

                  {/* <br /> */}
                  <Calendar
                    id="icon"
                    value={
                      financialYearCalendarDatesArray[i + 1]?.to || ""
                    }
                    onChange={(e) => {
                      this.dateOnChangeNew(e, i + 1, false, true);
                    }}
                    onBlur={(e) => this.dateOnBlurNew(e, i + 1, false, true)}
                    // minDate={new Date(2020, 0, 1)}
                    showIcon
                    dateFormat="yy-mm-dd"
                    placeholder={
                      TranslationFile.YearFormat[userSelectedLanguage]
                    }
                    disabled={
                      linkSharedUser == 3 ||
                      (responsePaymentEntryNo > 0 && allowEdit == true)
                    }
                    locale={localeLang}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </center>
      );
    }
    return elements;
  }

  navigateToIncomeStatementPage() {
    const {
      organizationNumber,
      companyName,
      postalCode,
      city,
      financialYearArrayState,
      financialYearSliderValue: sliderValue
    } = this.state;

    let { companyInformation, sessionDetails, login, sideBarReducer } =
      this.props;
    let financialYearArray = financialYearCalendarDatesArray;
    let isIncomplete = false;

    // let incomeStatementURL =
    //   "/annualreport/" +
    //   sessionDetails["sessionDetails"].values.uuid +
    //   "/incomeStatement";
    // this.props.history.push(incomeStatementURL);

    if (organizationNumber == "") {
      this.setState({
        isOrganizationNoMissing: true
      });
      isIncomplete = true;
    } else
      this.setState({
        isOrganizationNoMissing: false
      });

    if (companyName == "") {
      this.setState({
        isOrganizationNameMissing: true
      });
      isIncomplete = true;
    } else
      this.setState({
        isOrganizationNameMissing: false
      });

    const cleanPostalCode = String(postalCode || "").replace(/\s/g, "");
    const isPostalCodeValid = cleanPostalCode.length === 5;
    const postalCodeFilledButInvalid =
      cleanPostalCode.length > 0 && !isPostalCodeValid;

    if (cleanPostalCode == "" || cleanPostalCode == 0) {
      this.setState({
        isPostalCodeMissing: true,
        isWrongPostalcodeFormat: false
      });
      isIncomplete = true;
    } else if (!isPostalCodeValid) {
      this.setState({
        isPostalCodeMissing: false,
        isWrongPostalcodeFormat: true
      });
      isIncomplete = true;
    } else
      this.setState({
        isPostalCodeMissing: false,
        isWrongPostalcodeFormat: false
      });

    if (city == "") {
      this.setState({
        isCityMissing: true
      });
      isIncomplete = true;
    } else
      this.setState({
        isCityMissing: false
      });

    if (isIncomplete) {
      if (postalCodeFilledButInvalid) {
        // Postal code entered but not exactly 5 digits
        this.toast.show({
          severity: "error",
          summary: TranslationFile.InvalidPostalCodeSummary[userSelectedLanguage],
          detail: TranslationFile.InvalidPostalCodeDetail[userSelectedLanguage],
          life: 3000
        });
      } else {
      this.toast.show({
        severity: "error",
        summary: TranslationFile.IncompleteText[userSelectedLanguage],
        detail: TranslationFile.FillMandatryFields[userSelectedLanguage],
        life: 5000
      });
     }
    } else {
      let currentyear = "",
        previousyear1 = "",
        previousyear2 = "",
        previousyear3 = "";

      let fyArray = [];

      if (financialYearArray.length !== sliderValue + 1) {
        financialYearArray = financialYearArray.slice(0, sliderValue + 1);
        this.setState({
          financialYearArrayState: financialYearArray
        });
      }

      // A slider value of N means "N previous years" are required,
      // i.e. N + 1 total year rows (current year + N previous years)
      // must have BOTH a valid from and to date before we can continue.
      let requiredYearsCount = sliderValue + 1;
      let isFinancialYearIncomplete = false;

      for (let idx = 0; idx < requiredYearsCount; idx++) {
        let entry = financialYearArray[idx];
        let isEntryValid =
          entry &&
          entry.from &&
          entry.to &&
          moment(entry.from).isValid() &&
          moment(entry.to).isValid();

        if (!isEntryValid) {
          isFinancialYearIncomplete = true;
          break;
        }
      }

      financialYearArray.length &&
        financialYearArray.map((i, idx) => {
          if (!i) return;
          let fromDate = moment(i.from).format("YYYY-MM-DD");
          let toDate = moment(i.to).format("YYYY-MM-DD");
          switch (idx) {
            case 0:
              currentyear = fromDate + " - " + toDate;
              fyArray.push(currentyear);
              break;
            case 1:
              previousyear1 = fromDate + " - " + toDate;
              fyArray.push(previousyear1);
              break;
            case 2:
              previousyear2 = fromDate + " - " + toDate;
              fyArray.push(previousyear2);
              break;
            case 3:
              previousyear3 = fromDate + " - " + toDate;
              fyArray.push(previousyear3);
              break;
          }
        });
      if (currentyear == "" || isFinancialYearIncomplete) {
        this.toast.show({
          severity: "error",
          summary: TranslationFile.IncompleteText[userSelectedLanguage],
          detail:
            TranslationFile.FillFinancialYearDetails[userSelectedLanguage],
          life: 5000
        });
      } else {
        let companyInformationValue = {
          organizationname: annualReportHeaderRequestObj.companyName,
          organizationnumber: annualReportHeaderRequestObj.registrationNo,
          postalcode: annualReportHeaderRequestObj.postalCode,
          city: annualReportHeaderRequestObj.city,
          financialYear: financialYearCalendarDatesArray,
          SIEIncomeStatement: "",
          SIEBalanceSheet: ""
        };

        // companyInformation.values = companyInformationValue;
        // axios
        // .post("/annualReport/insertReportHeader", companyInformationReqPOST)
        // .then((response) => {
        //   if (response.data != "") {
        let currentPageName = ["Company Information"];
        if (sideBarGreenTickPages.length == 0)
          sideBarReducer.values = currentPageName;

        let possibleAccessablePagesListLSString = localStorage.getItem(
          "possibleAccessablePages"
        );

        if (possibleAccessablePagesListLSString == null) {
          let possibleNavigationPagesList = [
            "My Dashboard"
            // "Company Information",
          ];
          possibleNavigationPagesList = [
            ...new Set(possibleNavigationPagesList)
          ];
          let possibleNavigationPagesListString = JSON.stringify(
            possibleNavigationPagesList
          );

          localStorage.setItem(
            "possibleAccessablePages",
            possibleNavigationPagesListString
          );
        } else {
          let possibleAccessablePagesListLSArray = JSON.parse(
            possibleAccessablePagesListLSString
          );

          if (
            !possibleAccessablePagesListLSArray.includes("Income Statement")
          ) {
            possibleAccessablePagesListLSArray.push("Income Statement");
            possibleAccessablePagesListLSArray = [
              ...new Set(possibleAccessablePagesListLSArray)
            ];
            let updatePossibleNavigationPagesListString = JSON.stringify(
              possibleAccessablePagesListLSArray
            );

            localStorage.setItem(
              "possibleAccessablePages",
              updatePossibleNavigationPagesListString
            );
          }
        }

        let incomeStatementURL =
          "/annualreport/" +
          sessionDetails["sessionDetails"].values.uuid +
          "/incomeStatement";
        this.props.history.push(incomeStatementURL);
        //   }
        // });
      }
    }
  }

  dialogBoxOnClick = (e) => {
    if (e.defaultPrevented) {
      this.setState({
        showProceedButton: false
      });
    }
  };

  removeFile = () => {
    this.setState({
      SIEMissingFieldsErrorArrayState: [],
      showProceedButton: false
    });

    this.sieFileErrorMsg.clear();
  };

  selectFile = (selectedFileCallback) => {
    selectedFile = selectedFileCallback.files[0];
    let selectedFileFormat = selectedFileCallback.files[0].name
      .split(".")
      .pop()
      .toUpperCase();

    if (
      selectedFileFormat != "SE" &&
      selectedFileFormat != "TXT" &&
      selectedFileFormat != "SIE"
    ) {
      this.toast.show({
        severity: "error",
        summary: TranslationFile.InvalidFileFormat[userSelectedLanguage],
        detail: TranslationFile.FileFormatWarning[userSelectedLanguage],
        life: 6000
      });

      this.setState({
        showProceedButton: false
      });
    } else {
      this.setState({
        showProceedButton: true,
        SIEMissingFieldsErrorArrayState: []
      });
    }

    // this.setState({
    //   SIEMissingFieldsErrorArrayState: [],
    // });

    this.sieFileErrorMsg.clear();
  };

  proceedBtnOnClick() {
    const {
      organizationNumber,
      companyName,
      postalCode,
      city,
      financialYearArrayState,
      sliderValue,
      isProceedButtonClicked
    } = this.state;
    let { companyInformation, sessionDetails, login, sideBarReducer } =
      this.props;

    this.setState({
      SIEMissingFieldsErrorArrayState: [],
      showProceedButton: false,
      SIEErrors: ""
    });

    if (!isProceedButtonClicked) {
      this.setState({
        isProceedButtonClicked: true
      });

      var file = selectedFile;
      const url = "/annualReport/uploadSIEFile";
      const formData = new FormData();
      formData.append("file", file);
      formData.append("reportGUID", currentReportGUIDFromUrl);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          "User-Session-Auth-Key":
            userSessionAuthKeyReturnValue.headers["User-Session-Auth-Key"]
        }
      };
      axios
        .post(url, formData, config)
        .then((sieUploadedResponse) => {
          if (sieUploadedResponse.data == "Completed") {
            axios
              .get(
                "/annualReport/getHeader?reportId=" + currentReportGUIDFromUrl,
                userSessionAuthKeyReturnValue
              )
              .then((headerResponse) => {
                let headerResponseData = headerResponse.data;
                let navigatedFromDashboardFYs = [];

                if (headerResponseData.currentYear != "")
                  this.formatDateAndCreateFinancialYearArray(
                    headerResponseData.currentYear,
                    navigatedFromDashboardFYs,
                    0
                  );

                if (headerResponseData.previousYear1 != "")
                  this.formatDateAndCreateFinancialYearArray(
                    headerResponseData.previousYear1,
                    navigatedFromDashboardFYs,
                    1
                  );

                if (headerResponseData.previousYear2 != "")
                  this.formatDateAndCreateFinancialYearArray(
                    headerResponseData.previousYear2,
                    navigatedFromDashboardFYs,
                    2
                  );

                if (headerResponseData.previousYear3 != "")
                  this.formatDateAndCreateFinancialYearArray(
                    headerResponseData.previousYear3,
                    navigatedFromDashboardFYs,
                    3
                  );
                this.setState({
                  organizationNumber: headerResponseData.registrationNo,
                  companyName: headerResponseData.companyName,
                  postalCode:
                    // headerResponseData.postalCode == 0
                    //   ? ""
                    //   :
                    headerResponseData.postalCode,
                  city: headerResponseData.city,
                  visible: false,
                  isProceedButtonClicked: false,
                  uploadedSIEFile: headerResponseData.sIEFile,
                  currentReportID: headerResponseData.reportID,
                  disableCompanyNo: false
                });

                // Show the Bolagsverket info toast only when the imported
                // company name is NOT a limited company (AB / Aktiebolag).
                // If it IS an AB, the toast stays hidden.
                const importedOrgName = headerResponseData.companyName || "";
                const isABFromSIE =
                  /\bAB\b/i.test(importedOrgName) ||
                  /aktiebolag/i.test(importedOrgName);

                if (!isABFromSIE) {
                  this.bolagsverketToast.show({
                    severity: "info",
                    summary: "Information",
                    sticky: true,
                    closable: false,

                    content: () => (
                      <div className="bolagsverket-toast-container">
                        <i className="pi pi-info-circle bolagsverket-toast-icon"></i>
                        <div className="bolagsverket-toast-content">
                          <div className="bolagsverket-toast-header">
                            <span className="bolagsverket-toast-header-text">
                              Information
                            </span>
                          </div>
                          <div className="bolagsverket-toast-message">
                            {TranslationFile.Information[userSelectedLanguage]}
                          </div>
                          <div className="bolagsverket-toast-footer">
                            <Button
                              label="OK"
                              className="p-button-sm bolagsverket-toast-ok-btn"
                              onClick={() => this.bolagsverketToast.clear()}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  });
                }

                let navigatedResponseObj = {
                  organizationnumber: headerResponseData.registrationNo,
                  organizationname: headerResponseData.companyName,
                  postalcode:
                    // headerResponseData.postalCode == 0
                    //   ? ""
                    //   :
                    headerResponseData.postalCode,
                  city: headerResponseData.city,
                  financialYear: navigatedFromDashboardFYs
                };

                annualReportHeaderRequestObj.companyName =
                  headerResponseData.companyName;
                annualReportHeaderRequestObj.registrationNo =
                  headerResponseData.registrationNo;
                annualReportHeaderRequestObj.postalCode =
                  // headerResponseData.postalCode == 0
                  //   ? ""
                  //   :
                  headerResponseData.postalCode;
                annualReportHeaderRequestObj.city = headerResponseData.city;

                companyInformation.values = navigatedResponseObj;

                if (headerResponseData.registrationNo != "") {
                  axios
                    .get(
                      "/annualReport/getCompletedPages?reportId=" +
                        headerResponseData.reportID,
                      userSessionAuthKeyReturnValue
                    )
                    .then((completedStatementTypesResponse) => {
                      sideBarReducer.values =
                        completedStatementTypesResponse.data;
                      sideBarGreenTickPages =
                        completedStatementTypesResponse.data;
                      sideBarGreenTickPages.push(
                        "My Dashboard"
                        // "Company Information",
                        // "Income Statement"
                      );
                      sideBarGreenTickPages = [
                        ...new Set(sideBarGreenTickPages)
                      ];
                      let updatePossibleNavigationPagesListString =
                        JSON.stringify(sideBarGreenTickPages);
                      localStorage.setItem(
                        "possibleAccessablePages",
                        updatePossibleNavigationPagesListString
                      );
                      this.setState({
                        reRender: true
                      });
                    });
                }
              });
          }
        })
        .catch((error) => {
          this.setState({
            isProceedButtonClicked: false,
            SIEErrors: error.response.data
          });

          let errorResponseData = error.response.data;

          if (errorResponseData.includes("missing")) {
            errorResponseData =
              "Missing Field : " + errorResponseData.split(":")[1];
          } else {
            errorResponseData = "Invalid Format Field : " + errorResponseData;
          }

          this.sieFileErrorMsg.show([
            {
              severity: "error",
              detail: errorResponseData,
              sticky: true
            }
          ]);
        });
    }
  }
  subtractMonths(date, months) {
    date.setMonth(date.getMonth() - months);
    return date;
  }

  showStatusAlertFunc(status) {}

  languageValue = (e) => {};

  callback = (annualReport, session, link, status) => {
    let sessionFromLS = localStorage.getItem("sessionUUID");
    if (status) {
      this.props.history.push(annualReport + sessionFromLS + link);
    }
    this.setState({
      reRender: true
    });
  };

  newUserSaveButton = () => {
    const {
      newUserEmailId,
      newUserUserId,
      newUserName,
      newLastName,
      newUserPassword,
      newUserConfirmPassword,
      passwordValidation
    } = this.state;

    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    if (newUserPassword != "" && !isPasswordValid) {
      this.setState({ showPasswordTooltip: true });
      if (this.passwordInputRef && this.passwordInputRef.current) {
        this.passwordInputRef.current.focus();
      }
      return;
    }

    if (newUserPassword != newUserConfirmPassword) {
      this.toast.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.PasswordMustMatchText[userSelectedLanguage],
        life: 5000
      });
    } else {
      if (
        newUserName != "" &&
        newLastName != "" &&
        newUserPassword != "" &&
        newUserConfirmPassword != "" &&
        isPasswordValid &&
        userSessionAuthKeyReturnValue
      ) {
        let userDetails = {
          userID: newUserUserId,
          userName: newUserName,
          lastName: newLastName,
          password: newUserPassword
        };
        axios
          .post(
            "/user/updateUsernamePasswordForUserID",
            userDetails,
            userSessionAuthKeyReturnValue
          )
          .then((response) => {
            if (response.data) {
              let userEmailPasswordDetails = {
                emailID: newUserEmailId,
                password: newUserPassword,
                checkHashCode: true
              };
              axios
                .post("/user/loginAndGetUser", userEmailPasswordDetails)
                .then((response) => {
                  const userAuthKey = response.headers["user-session-auth-key"];
                  response.data["User-Session-Auth-Key"] = userAuthKey;
                  localStorage.setItem(
                    "rebelSkoolUser",
                    JSON.stringify(response.data)
                  );
                  this.setState({ showUserNamePasswordDialogBox: false });
                  window.location.reload(false);
                });
            }
          });
      }
    }
  }

  handleFocus = () => {
    const inputElement = this.inputMaskRef.current?.element;
    if (inputElement) {
      inputElement.setSelectionRange(0, 0);
    }
  };

  redirectToHomePage() {
    window.location.assign("/#/annualreport");
  }

  downloadSIEFile() {
    const { currentReportID } = this.state;
    if (userSessionAuthKeyReturnValue) {
      axios
        .get(
          "/annualReport/downloadSIEFile?reportID=" + currentReportID,
          userSessionAuthKeyReturnValue
        )
        .then((response) => {
          response["Access-Control-Expose-Headers"] = "Content-Disposition";
          const filename =
            response.headers["content-disposition"].split("filename=")[1];
          const blob = new Blob([response.data]);
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
    }
  }

  sideBarStatus = (e) => {
    this.setState({
      sideBarStatus: e
    });
  };

  sideBarCallback = (value) => {
    if (value) {
      this.toast.show({
        severity: "info",
        summary: "Info",
        detail: TranslationFile.CompleteCurrentPageText[userSelectedLanguage],
        life: 5000
      });
      this.setState({
        reRender: true
      });
    }
  };

  closeTipsDialogBox() {
    const randomIndex = Math.floor(Math.random() * videoList.length);

    this.setState({ tipsDialog: false });

    setTimeout(() => {
      this.setState({
        randomVideoFileName: videoList[randomIndex].videoPath,
        randomVideoFileTitle: videoList[randomIndex].videoTitle
      });
    }, 1000);
  }

  tourStatus = (e) => {
    this.setState({ run: e });
  };

  componentWillUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  }

  checkScreenSize = () => {
    if (
      window.innerWidth < 900 &&
      !localStorage.getItem("hideBestViewDialog")
    ) {
      this.setState({ isDialogOpen: true });
    }
  };

  closeDialog = () => {
    this.setState({ isDialogOpen: false });
    localStorage.setItem("hideBestViewDialog", true);
  };

  toggleMask = () => {
    this.setState((prevState) => ({
      isMasked: !prevState.isMasked
    }));
  };

  validatePassword(password) {
    const validation = {
      minLength: password.length >= 6,
      uppercase: /[A-Z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password)
    };

    this.setState({
      passwordValidation: validation
    });
  }

  newUserPasswordOnChange(e)  {
     const minLength = e.length >= 6;
    const uppercase = /[A-Z]/.test(e);
    const number = /[0-9]/.test(e);
    const specialChar = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(e);
    const isPasswordValid = minLength && uppercase && number && specialChar;

    this.setState({
      newUserPassword: e,
      showPasswordTooltip: e.length > 0 && !isPasswordValid,
      passwordValidation: {
        minLength,
        uppercase,
        number,
        specialChar
      }
    });
  }

  newUserConfirmPasswordOnChange(e) {
    this.setState({
      newUserConfirmPassword: e
    });
  }

  checkPasswordMatch = () => {
    const { newUserPassword, newUserConfirmPassword } = this.state;
    if (newUserPassword != "" && newUserConfirmPassword != "") {
      if (newUserPassword == newUserConfirmPassword) {
        this.setState({
          passwordMismatch: false
        });
      } else {
        this.setState({
          passwordMismatch: true
        });
      }
    }
  };

  render() {
    let { currentPageName, readOnly, showWIPStatus } = this.props;
    const {
      isMasked,
      isWrongOrganizationNo,
      organizationNumber,
      companyName,
      postalCode,
      city,
      sliderValue,
      isCityMissing,
      isOrganizationNameMissing,
      isOrganizationNoMissing,
      isPostalCodeMissing,
      isWrongPostalcodeFormat,
      financialYearArrayState,
      SIEMissingFieldsErrorArrayState,
      showProceedButton,
      visible,
      disableCompanyNo,
      showUserNamePasswordDialogBox,
      newUserPassword,
      newUserConfirmPassword,
      newUserName,
      newLastName,
      newUserEmailId,
      isProceedButtonClicked,
      financialYearSliderValue,
      calendarDateHardCodedValue,
      uploadedSIEFile,
      reportAccessStatusFromProps,
      randomVideoFileName,
      tipsDialog,
      randomVideoFileTitle,
      isDialogOpen,
      pageLoading,
      passwordMismatch,
      accessLevel,
      passwordValidation,
      showPasswordTooltip,
      bolagsverketToast
    } = this.state;
    ////////////

    const isPasswordValid =
      passwordValidation.minLength &&
      passwordValidation.uppercase &&
      passwordValidation.number &&
      passwordValidation.specialChar;

    if (
      financialYearCalendarDatesArray.length != undefined &&
      financialYearCalendarDatesArray.length > 0 &&
      financialYearCalendarDatesArray[0] != undefined
    ) {
      submissionLimitToDate = moment(financialYearCalendarDatesArray[0].to)
        .add(7, "month")
        .subtract(1, "day")._d;
      submissionLimitToDate = moment(submissionLimitToDate).format(
        "YYYY-MM-DD"
      );
    }
    ////////////
    let pageUnderWIP = false;
    if (showWIPStatus.values != undefined) {
      if (showWIPStatus.values) {
        pageUnderWIP = true;
      } else {
        pageUnderWIP = false;
      }
    }

    const { oddsFilters, sideBarReducer } = this.props;
    const currentDateMinus13Months = this.subtractMonths(new Date(), 13);

    return (
      <div>
        {accessLevel !== 4 ? (
          <div>
            <div>
              <Joyride
                continuous
                run={this.state.run}
                disableBeacon={true}
                showProgress={false}
                showSkipButton
                steps={steps}
                scrollToFirstStep
                scrollToSteps={true}
                disableScrolling={false}
                scrollOffset={100}
                locale={{
                  next: TranslationFile.nextBtn[userSelectedLanguage],
                  back: TranslationFile.backText[userSelectedLanguage],
                  skip: TranslationFile.skipText[userSelectedLanguage],
                  last: "OK",
                  close: "Close"
                }}
                styles={{
                  options: {
                    zIndex: 10000
                  }
                }}
              />

              <Toast
                ref={(el) => {
                  this.toast = el;
                }}
                className="companyInfoErrorToast"
                style={{ marginTop: "32%" }}
              ></Toast>

              <Toast
                ref={(el) => {
                  this.bolagsverketToast = el;
                }}
                position="bottom-right"
              ></Toast>

              <NavBarHeader
                callBack={this.callback}
                isAppPortal={true}
                isHomePage={false}
              />
              <div
                className={
                  pageUnderWIP
                    ? "companyInfoSideBarWithWIP"
                    : "companyInfoSideBar"
                }
              >
                <Sidebar
                  children="Company Information"
                  sideBarStatus={this.sideBarStatus.bind(this)}
                  sideBarCallback={this.sideBarCallback.bind(this)}
                  tourStatus={this.tourStatus.bind(this)}
                />
              </div>
              {pageLoading ? (
                <div className="repPageLoadingDiv">
                  <center>
                    <ProgressSpinner
                      style={{
                        width: "50px",
                        height: "40px",
                        top: "118px"
                      }}
                      className="repPageLoading"
                    />
                  </center>
                </div>
              ) : (
                <>
                  <div className="CIcontentParentDiv">
                    <div className="CIcontentParentDiv">
                      <div className="createARLabel">
                        {TranslationFile.CreateAR[userSelectedLanguage]}
                      </div>
                      <div
                        className="upload-second-div"
                        style={{ pointerEvents: readOnly.values && "none" }}
                      >
                        <div className="companyIndiImportInsideDiv">
                          {uploadedSIEFile != undefined &&
                          uploadedSIEFile != "" &&
                          uploadedSIEFile != null ? (
                            <Dropdown as={ButtonGroup}>
                              <Button
                                label={
                                  TranslationFile.IncomestateImportText1[
                                    userSelectedLanguage
                                  ]
                                }
                                icon="pi pi-file-import"
                                onClick={() => this.setState({ visible: true })}
                                disabled={
                                  linkSharedUser == 3 ||
                                  responsePaymentEntryNo > 0
                                }
                              />

                              <Dropdown.Toggle
                                split
                                id="dropdown-split-basic"
                                className="import-sie-dropdown"
                              />

                              <Dropdown.Menu className="download-sie-dropdown">
                                <Dropdown.Item
                                  onClick={() => this.downloadSIEFile()}
                                >
                                  <span
                                    className="pi pi-download"
                                    style={{ marginRight: "5px" }}
                                  ></span>
                                  {
                                    TranslationFile.DownloadSIEFile[
                                      userSelectedLanguage
                                    ]
                                  }
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : (
                            <Button
                              label={
                                TranslationFile.IncomestateImportText1[
                                  userSelectedLanguage
                                ]
                              }
                              className="import-btn-upload"
                              icon="pi pi-file-import"
                              onClick={() => this.setState({ visible: true })}
                              disabled={linkSharedUser == 3}
                            />
                          )}
                        </div>
                        <Dialog
                          visible={this.state.showRemoveFYConfimationDialog}
                          style={{ width: "32rem" }}
                          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                          header={
                            TranslationFile.RemoveFYFromYourReportText[
                              userSelectedLanguage
                            ]
                          }
                          blockScroll
                          modal
                          footer={this.deleteFormFooter}
                          onHide={() =>
                            this.setState({
                              showRemoveFYConfimationDialog: false
                            })
                          }
                        >
                          <div className="confirmation-content">
                            <span>
                              <span>
                                {
                                  TranslationFile.clickYestoDeleteText[
                                    userSelectedLanguage
                                  ]
                                }
                              </span>
                            </span>
                          </div>
                        </Dialog>

                        <Dialog
                          header={
                            TranslationFile.IncomestateImportText1[
                              userSelectedLanguage
                            ]
                          }
                          blockScroll
                          visible={visible}
                          onHide={() =>
                            this.setState({
                              visible: false,
                              SIEMissingFieldsErrorArrayState: [],
                              SIEErrors: ""
                            })
                          }
                          id="import-dialog"
                          style={{ width: "50vw" }}
                          onClick={this.dialogBoxOnClick}
                          className="import_file-sub_title"
                        >
                          {isProceedButtonClicked ? (
                            <>
                              <div className="sieUploadLoadingDiv">
                                <center>
                                  <img
                                    src={SieLoadingGif}
                                    alt="loading..."
                                    style={{
                                      width: "14em",
                                      height: "14em",
                                      marginTop: "1em"
                                    }}
                                    className="companyInfoProceedSpinner"
                                  />
                                  <br />
                                  <i>
                                    {
                                      TranslationFile.processingSIEFile[
                                        userSelectedLanguage
                                      ]
                                    }
                                  </i>
                                </center>
                              </div>
                              <center>
                                <Button
                                  label={
                                    TranslationFile.clickhrTipsandGuideText[
                                      userSelectedLanguage
                                    ]
                                  }
                                  onClick={() =>
                                    this.setState({
                                      tipsDialog: true
                                    })
                                  }
                                />
                              </center>
                            </>
                          ) : (
                            <div>
                              <FileUpload
                                maxFileSize={10000000000}
                                name="demo[]"
                                chooseLabel={
                                  TranslationFile.ChooseLabel[
                                    userSelectedLanguage
                                  ]
                                }
                                emptyTemplate={
                                  <p className="import_file_m-0">
                                    {
                                      TranslationFile.IncomestateImportDag[
                                        userSelectedLanguage
                                      ]
                                    }
                                  </p>
                                }
                                onSelect={this.selectFile}
                                multiple={false}
                                onRemove={this.removeFile}
                              />

                              {showProceedButton != "" && (
                                <div className="proceed-btn-div">
                                  <Button
                                    onClick={this.proceedBtnOnClick.bind(this)}
                                  >
                                    {isProceedButtonClicked ? (
                                      <ProgressSpinner
                                        style={{
                                          width: "50px",
                                          height: "40px"
                                        }}
                                        className="companyInfoProceedSpinner"
                                      />
                                    ) : (
                                      TranslationFile
                                        .IncomestateImportbtnPrceed[
                                        userSelectedLanguage
                                      ]
                                    )}
                                  </Button>
                                </div>
                              )}
                            </div>
                          )}
                          <Messages ref={(el) => (this.sieFileErrorMsg = el)} />
                        </Dialog>

                        <Dialog
                          header={
                            TranslationFile.TipsAndGuideText[
                              userSelectedLanguage
                            ]
                          }
                          visible={tipsDialog}
                          blockScroll
                          style={{ width: "80vw", height: "100vw" }}
                          onHide={() => this.closeTipsDialogBox()}
                        >
                          <center>
                            <h5>{randomVideoFileTitle}</h5>
                          </center>

                          <video
                            width="100%"
                            height="90%"
                            className="tipsVideoTag"
                            autoPlay
                            muted
                            loop
                            ref={this.videoRef}
                            onCanPlay={() => this.setPlayBack()}
                          >
                            <source
                              src={randomVideoFileName}
                              type="video/mp4"
                            />
                          </video>
                        </Dialog>
                      </div>
                      <div className="info-year-container">
                        <Fieldset
                          style={{ pointerEvents: readOnly.values && "none" }}
                          className="company_fieldset1"
                          legend={
                            TranslationFile.IncomestateHeader1[
                              userSelectedLanguage
                            ]
                          }
                        >
                          <div className="info-number-name">
                            <Row className="info-row">
                              <Col className="info-col">
                                <label
                                  htmlFor="OrganizationNumber"
                                  className="companyInformationTextBoxTitle"
                                >
                                  {
                                    TranslationFile.IncomestateCompanyOrgNo[
                                      userSelectedLanguage
                                    ]
                                  }
                                  <p className="companyInformationMandatoryStart">
                                    *
                                  </p>
                                </label>
                                <InputMask
                                  ref={this.inputMaskRef}
                                  onFocus={this.handleFocus}
                                  className={
                                    isOrganizationNoMissing
                                      ? "missingFieldsStyle"
                                      : "info-org-no"
                                  }
                                  mask="999999-9999"
                                  value={organizationNumber}
                                  onComplete={(e) =>
                                    this.organizationNoOnComplete(e)
                                  }
                                  onChange={(e) =>
                                    this.organizationNoOnChange(e)
                                  }
                                  useGrouping={false}
                                  disabled={
                                    disableCompanyNo ||
                                    linkSharedUser == 3 ||
                                    responsePaymentEntryNo > 0
                                  }
                                  name="rblCompanyNo"
                                  autocomplete="new-password"
                                />
                              </Col>
                              <Col className="info-col">
                                <label
                                  htmlFor="CompanyName"
                                  className="companyInformationTextBoxTitle"
                                >
                                  {
                                    TranslationFile.IncomestateCompanyOrgName[
                                      userSelectedLanguage
                                    ]
                                  }
                                  <p className="companyInformationMandatoryStart">
                                    *
                                  </p>
                                </label>
                                <InputText
                                  className={
                                    isOrganizationNameMissing
                                      ? "missingFieldsStyle"
                                      : "info-org-name"
                                  }
                                  value={companyName}
                                  onChange={(e) => this.companyNameOnChange(e)}
                                  onBlur={(e) => this.companyNameOnBlur(e)}
                                  disabled={linkSharedUser == 3}
                                  onInput={(e) => this.companyNameOnInput(e)}
                                  name="rblCompanyName"
                                  autocomplete="new-password"
                                />
                              </Col>
                            </Row>
                            <Row className="info-row">
                              <Col className="info-col">
                                <label
                                  htmlFor="PostalCode"
                                  className="companyInformationTextBoxTitle"
                                >
                                  {
                                    TranslationFile
                                      .IncomestateCompanyPostalcode[
                                      userSelectedLanguage
                                    ]
                                  }
                                  <p className="companyInformationMandatoryStart">
                                    *
                                  </p>
                                </label>
                                <InputText
                                  // inputId={
                                  //   isPostalCodeMissing
                                  //     ? "withoutgroupingIncomplete"
                                  //     : "withoutgrouping"
                                  // }
                                  className={
                                    isPostalCodeMissing || isWrongPostalcodeFormat
                                      ? "missingFieldsStyle"
                                      : "info-org-postal"
                                  }                                  
                                  keyfilter="int" 
                                  inputmode="numeric"
                                  value={postalCode}
                                  // onValueChange={(e) => this.PostalcodeOnChange(e)}
                                  onChange={(e) => this.PostalcodeOnChange(e)}
                                  onBlur={(e) => this.postalCodeOnBlur(e)}
                                  // useGrouping={false}
                                  disabled={linkSharedUser == 3}
                                  name="rblCompanyPostalCode"
                                  autocomplete="new-password"
                                />
                              {/*  {isWrongPostalcodeFormat && (
                                  <div
                                    className="error"
                                    style={{ color: "red", fontSize: "0.85rem" }}
                                  >
                                    {(TranslationFile.PostalCodeMustBe5Digits &&
                                      TranslationFile.PostalCodeMustBe5Digits[
                                        userSelectedLanguage
                                      ]) ||
                                      "Postal code must be 5 digits"}
                                  </div>
                                )} */}
                              </Col>
                              <Col className="info-col">
                                <label
                                  htmlFor="City"
                                  className="companyInformationTextBoxTitle"
                                >
                                  {
                                    TranslationFile.IncomestateCompanyCity[
                                      userSelectedLanguage
                                    ]
                                  }
                                  <p className="companyInformationMandatoryStart">
                                    *
                                  </p>
                                </label>
                                <InputText
                                  className={
                                    isCityMissing
                                      ? "missingFieldsStyle"
                                      : "info-org-city"
                                  }
                                  value={city}
                                  onChange={(e) => this.cityOnChange(e)}
                                  onBlur={(e) => this.cityOnBlur(e)}
                                  disabled={linkSharedUser == 3}
                                  name="rblCompanyCity"
                                  autocomplete="new-password"
                                />
                              </Col>
                            </Row>
                          </div>
                        </Fieldset>
                        <Fieldset
                          className="company_fieldset2"
                          legend={
                            TranslationFile.IncomestateHeader2[
                              userSelectedLanguage
                            ]
                          }
                        >
                          <center>
                            <div
                              style={{
                                pointerEvents: readOnly.values && "none"
                              }}
                            >
                              <div className="year-cal-label-container">
                                <br></br>
                                <div className="year-cal-declarationYearLbl">
                                  {
                                    TranslationFile.IncomestateYearDeclare[
                                      userSelectedLanguage
                                    ]
                                  }
                                </div>

                                <Row className="companyInfoFyRow">
                                  <Col>
                                    <div className="companyInfoStartEndDateLbl">
                                      <div className="companyInfoStartDateLblDiv">
                                        {
                                          TranslationFile
                                            .IncomestateYearStartdate[
                                            userSelectedLanguage
                                          ]
                                        }
                                      </div>
                                      <Calendar
                                        id="icon"
                                        value={
                                          financialYearCalendarDatesArray[0] 
                                             ?.from || ""
                                        }
                                        onChange={(e) => {
                                          this.dateOnChangeNew(
                                            e,
                                            0,
                                            true,
                                            false
                                          );
                                        }}
                                        onBlur={(e) =>
                                          this.dateOnBlurNew(e, 0, true, false)
                                        }
                                        showIcon
                                        dateFormat="yy-mm-dd"
                                        placeholder={
                                          TranslationFile.YearFormat[
                                            userSelectedLanguage
                                          ]
                                        }
                                        viewDate={currentDateMinus13Months}
                                        disabled={
                                          linkSharedUser == 3 ||
                                          (responsePaymentEntryNo > 0 &&
                                            allowEdit == true)
                                        }
                                        locale={localeLang}
                                      />
                                    </div>
                                  </Col>
                                  <Col>
                                    <div className="companyInfoStartEndDateLbl">
                                      <div className="companyInfoEndDateLblDiv">
                                        {
                                          TranslationFile
                                            .IncomestateYearEnddate[
                                            userSelectedLanguage
                                          ]
                                        }
                                      </div>

                                      <Calendar
                                        id="icon"
                                        value={
                                          financialYearCalendarDatesArray[0] !=
                                          undefined
                                            ? financialYearCalendarDatesArray[0]
                                                .to
                                            : ""
                                        }
                                        onChange={(e) => {
                                          this.dateOnChangeNew(
                                            e,
                                            0,
                                            false,
                                            true
                                          );
                                        }}
                                        onBlur={(e) =>
                                          this.dateOnBlurNew(e, 0, false, true)
                                        }
                                        showIcon
                                        dateFormat="yy-mm-dd"
                                        placeholder={
                                          TranslationFile.YearFormat[
                                            userSelectedLanguage
                                          ]
                                        }
                                        disabled={
                                          linkSharedUser == 3 ||
                                          (responsePaymentEntryNo > 0 &&
                                            allowEdit == true)
                                        }
                                        locale={localeLang}
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                              {submissionLimitToDate != "" &&
                                submissionLimitToDate != undefined && (
                                  <div className="year-limit-info">
                                    <center>
                                      <i
                                        className="pi pi-info-circle"
                                        style={{ marginRight: "5px" }}
                                      ></i>
                                      <span style={{ marginRight: "2px" }}>
                                        {
                                          TranslationFile.CI_FY_Summary_Line[
                                            userSelectedLanguage
                                          ]
                                        }{" "}
                                      </span>
                                      <span>{submissionLimitToDate}</span>
                                    </center>
                                  </div>
                                )}

                              <div className="year-drop-label-main">
                                <span className="year-drop-label">
                                  {
                                    TranslationFile.CI_FY_Select[
                                      userSelectedLanguage
                                    ]
                                  }
                                </span>
                              </div>
                              <center>
                                <div className="slider-div">
                                  <div className="slider__container">
                                    <Slider
                                      marks={marks}
                                      step={null}
                                      defaultValue={0}
                                      max={3}
                                      value={financialYearSliderValue}
                                      onChange={this.handleSliderChangeNew}
                                      className="custom-slider"
                                      disabled={
                                        linkSharedUser == 3 ||
                                        (responsePaymentEntryNo > 0 &&
                                          allowEdit == true)
                                      }
                                    />
                                  </div>
                                </div>
                              </center>
                              <br></br>
                              <div>
                                {this.createElements(financialYearSliderValue)}
                              </div>
                            </div>
                          </center>
                          <center>
                            <Button
                              label={
                                TranslationFile.nextBtn[userSelectedLanguage]
                              }
                              aria-label={
                                TranslationFile.yearBtnSaveText[
                                  userSelectedLanguage
                                ]
                              }
                              onClick={() =>
                                this.navigateToIncomeStatementPage()
                              }
                              className="year-btn-save"
                              style={{
                                width: "100px",
                                height: "42px",
                                marginTop: "2%",
                                marginBottom: "3%"
                              }}
                            />
                          </center>
                        </Fieldset>
                      </div>
                    </div>
                    <ScrolltoTop />
                    <Footer_contact_tab
                      sideBar={this.state.sideBarStatus}
                      isCorpPortal={false}
                      isHomePage={true}
                    />
                  </div>
                  <div>
                    <Dialog
                      header={
                        TranslationFile.NewUserLoginHereText[
                          userSelectedLanguage
                        ]
                      }
                      blockScroll
                      visible={showUserNamePasswordDialogBox}
                      onHide={() =>
                        this.setState({ showUserNamePasswordDialogBox: false })
                      }
                      style={{ width: "30vw" }}
                      className="newUserDialogBox"
                    >
                      <div>
                        <div style={{ padding: "20px 30px" }}>
                          <div>
                            <div style={{ textAlign: "left" }}>
                              {
                                TranslationFile.LoginFirstName[
                                  userSelectedLanguage
                                ]
                              }
                            </div>
                            <InputText
                              value={newUserName}
                              onChange={(e) => {
                                this.setState({ newUserName: e.target.value });
                              }}
                              placeholder={
                                TranslationFile.LoginFirstName[
                                  userSelectedLanguage
                                ]
                              }
                              name="rblCompanyNewUserFName"
                              autocomplete="new-password"
                            />
                          </div>
                          <br></br>
                          <div>
                            <div style={{ textAlign: "left" }}>
                              {
                                TranslationFile.LoginLastName[
                                  userSelectedLanguage
                                ]
                              }
                            </div>
                            <InputText
                              value={newLastName}
                              onChange={(e) => {
                                this.setState({ newLastName: e.target.value });
                              }}
                              placeholder={
                                TranslationFile.LoginLastName[
                                  userSelectedLanguage
                                ]
                              }
                              name="rblCompanyNewUserLName"
                              autocomplete="new-password"
                            />
                          </div>
                          <br></br>
                          <div>
                            <div style={{ textAlign: "left" }}>
                              {
                                TranslationFile.FooterEmailLabel[
                                  userSelectedLanguage
                                ]
                              }
                            </div>
                            <InputText
                              value={newUserEmailId}
                              placeholder={
                                TranslationFile.EmailIdText[
                                  userSelectedLanguage
                                ]
                              }
                              disabled
                            />
                          </div>
                          <br></br>
                          <div>
                            <div style={{ textAlign: "left" }}>
                              {
                                TranslationFile.IncomestateYearPassword[
                                  userSelectedLanguage
                                ]
                              }
                            </div>
                            <div className="p-inputgroup">
                              <input
                                id="newUserPassword"
                                ref={this.passwordInputRef}
                                type={isMasked ? "password" : "text"}
                                value={newUserPassword}
                                data-tooltip-id="password-requirements"
                                onChange={(e) => {
                                  this.newUserPasswordOnChange(e.target.value);
                                }}
                                onFocus={() => {
                          const password = this.state.newUserPassword;

                          const validation = {
                            minLength: password.length >= 6,
                            uppercase: /[A-Z]/.test(password),
                            number: /[0-9]/.test(password),
                            specialChar:
                              /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                password
                              )
                          };

                          this.setState({
                            passwordValidation: validation,
                            showPasswordTooltip: !(
                              validation.minLength &&
                              validation.uppercase &&
                              validation.number &&
                              validation.specialChar
                            )

                          });
                        }}
                                required
                                placeholder={
                                  TranslationFile.IncomestateYearPassword[
                                    userSelectedLanguage
                                  ]
                                }
                                className="p-inputtext p-component"
                                onBlur={() => {
                                  this.checkPasswordMatch();
                                  this.setState({ 
                                    showPasswordTooltip: false 
                                  });
                                }}
                                autocomplete="new-password"
                              />
                              <span
                                className="p-inputgroup-addon"
                                onClick={this.toggleMask}
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  className={
                                    isMasked ? "pi pi-eye-slash" : "pi pi-eye"
                                  }
                                  style={{ fontSize: "1.2rem" }}
                                ></i>
                              </span>
                            </div>

                                            <Tooltip
                                              anchorSelect="#newUserPassword"
                                              id="password-requirements"
                                              isOpen={showPasswordTooltip}
                                              place="left"
                                              offset={10} 
                                              openEvents={{}}
                                              closeEvents={{}}
                                              globalCloseEvents={{}}
                                              clickable
                                              className="password-tooltip"
                                              style={{
                                                zIndex: 9999,
                                                backgroundColor: "#ffb3ff",
                                                color: "#ff0000",
                                                borderRadius: "8px",
                                                padding: "10px"
                                              }}
                                            >
                                              <>
                                                <b className="passwordReqTooltipHeader">
                                                  {
                                                    TranslationFile.passwordRequirements[
                                                      userSelectedLanguage
                                                    ]
                                                  }
                                                </b>
                                              </>
                                              <hr className="passwordReqTooltipHeaderHrTag"></hr>
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  gap: "5px",
                                                  fontWeight: "500"
                                                }}
                                              >
                                                <div
                                                  style={{
                                                    color: passwordValidation.minLength ? "green" : "red"
                                                  }}
                                                >
                                                  {passwordValidation.minLength ? "✓" : "✗"}{" "}
                                                  {
                                                    TranslationFile.minimum6characters[
                                                      userSelectedLanguage
                                                    ]
                                                  }
                                                </div>
                          
                                                <div
                                                  style={{
                                                    color: passwordValidation.uppercase ? "green" : "red"
                                                  }}
                                                >
                                                  {passwordValidation.uppercase ? "✓" : "✗"}{" "}
                                                  {
                                                    TranslationFile.atleast1uppercaseletter[
                                                      userSelectedLanguage
                                                    ]
                                                  }
                                                </div>
                          
                                                <div
                                                  style={{
                                                    color: passwordValidation.number ? "green" : "red"
                                                  }}
                                                >
                                                  {passwordValidation.number ? "✓" : "✗"}{" "}
                                                  {TranslationFile.atleast1number[userSelectedLanguage]}
                                                </div>
                          
                                                <div
                                                  style={{
                                                    color: passwordValidation.specialChar
                                                      ? "green"
                                                      : "red"
                                                  }}
                                                >
                                                  {passwordValidation.specialChar ? "✓" : "✗"}{" "}
                                                  {
                                                    TranslationFile.atleast1specialcharacter[
                                                      userSelectedLanguage
                                                    ]
                                                  }
                                                </div>
                                              </div>
                                            </Tooltip> 

                          </div>
                          <br></br>

                          <div>
                            <div style={{ textAlign: "left" }}>
                              {
                                TranslationFile.IncomestateYearConPassword[
                                  userSelectedLanguage
                                ]
                              }
                            </div>
                            <div className="p-inputgroup">
                              <input
                                type={isMasked ? "password" : "text"}
                                value={newUserConfirmPassword}
                                onChange={(e) => {
                                  this.newUserConfirmPasswordOnChange(e.target.value);
                                }}
                                required
                                placeholder={
                                  TranslationFile.IncomestateYearConPassword[
                                    userSelectedLanguage
                                  ]
                                }
                                className="p-inputtext p-component"
                                onBlur={() => this.checkPasswordMatch()}
                                autocomplete="new-password"
                              />

                              <span
                                className="p-inputgroup-addon"
                                onClick={this.toggleMask}
                                style={{ cursor: "pointer" }}
                              >
                                <i
                                  className={
                                    isMasked ? "pi pi-eye-slash" : "pi pi-eye"
                                  }
                                  style={{ fontSize: "1.2rem" }}
                                ></i>
                              </span>
                            </div>

                            {passwordMismatch &&
                              newUserConfirmPassword != "" && (
                                <div className="error">
                                  {
                                    TranslationFile.PasswordMustMatchText[
                                      userSelectedLanguage
                                    ]
                                  }
                                </div>
                              )}
                          </div>
                        </div>
                        <br></br>
                        <center>
                          <Button
                            icon="pi pi-check"
                            aria-label={
                                                  TranslationFile.yearBtnSaveText[userSelectedLanguage]
                                                }
                                                className="year-btn-save"
                                                style={{
                                                  width: "250px",
                                                  height: "44px",
                                                  fontSize: "1.2rem",
                                                  marginTop: "6%",
                                                  color: "white",
                                                  opacity:
                                                  newUserPassword != "" &&
                                                  newUserConfirmPassword != "" &&
                                                  newUserName != "" &&
                                                  newLastName != "" &&
                                                  !passwordMismatch &&
                                                  passwordValidation.minLength &&
                                                  passwordValidation.uppercase &&
                                                  passwordValidation.number &&
                                                  passwordValidation.specialChar
                                                    ? 1
                                                    : 0.6
                                                }}
                            onClick={this.newUserSaveButton}
                          >
                            {
                              TranslationFile.IncomestateYearsave[
                                userSelectedLanguage
                              ]
                            }
                          </Button>
                        </center>
                      </div>
                    </Dialog>
                  </div>
                </>
              )}
            </div>

            {isDialogOpen ? (
              <Dialog
                header="Best Viewed on Laptop"
                visible={isDialogOpen}
                className="best_view_dialogbox"
                onHide={this.closeDialog}
                maskClassName="best-view-dialog"
                blockScroll={true}
              >
                <p>
                  This page is optimized for laptop view. For a better
                  experience, please switch to a device with a larger screen.
                </p>
                <center>
                  <Button
                    label="Close"
                    icon="pi pi-times"
                    onClick={this.closeDialog}
                  />
                </center>
              </Dialog>
            ) : (
              ""
            )}
          </div>
        ) : (
          <NoAccess />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, null)(CompanyInformation);